import firebase, { database } from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import { getUsersByCompany } from './cacheService'
import { ensureReportAuth } from './core/reportAuth'
import { fetchTalentAndNetwork } from './core/talentAndNetwork'
import _ from 'lodash'
import format from 'date-fns/format'
import endOfMonth from "date-fns/end_of_month";
import addDays from 'date-fns/add_days';
import startOfWeek from 'date-fns/start_of_week'
import subMonths from 'date-fns/sub_months';
import subWeeks from 'date-fns/sub_weeks';
import startOfISOWeek from 'date-fns/start_of_iso_week'
import isFirstDayOfMonth from 'date-fns/is_first_day_of_month'
import parse from 'date-fns/parse'
import addMonths from 'date-fns/add_months';
import addYears from 'date-fns/add_years';
import { isWeekend } from 'date-fns';
// import question from './question'; // File removed!
//import axios from 'axios'
//const apiUrl = 'http://54.179.6.33:3000'
//const apiUrl = 'http://localhost:3000'
export default {
  namespaced: true,
  state: {
    user: '',
    team: '',
    engagement: {
      engagementKey: [],
      engagementType:'',
      challenges: {
        dailyCheck: "",
        peerFeedback: "",
        feedback: "",
        happilyVillage: "",
        superFeedback: "",
        rewards: "",
        recognition: "",
        favoritedSparks: "",
        superRecognition: "",
        NetworkBuilding: "",
      },
    },
    directReports: {
      engagedFocus: 0,
      engagedFocusType: "superEngaged",
      engagedValue: {
        superEngaged: 0,
        oldSuperEngaged: 0,
        highlyEngaged: 0,
        oldHighlyEngaged: 0,
        moderatelyEngaged: 0,
        oldModeratelyEngaged: 0,
        somewhatEngaged: 0,
        oldSomewhatEngaged: 0,
        notEngaged: 0,
        oldNotEngaged: 0,
      },
      engagedData: [],
    },
    directReportsLoading: true,
    directReportsEngagedValue: {
      superEngaged: 0,
      oldSuperEngaged: 0,
      highlyEngaged: 0,
      oldHighlyEngaged: 0,
      moderatelyEngaged: 0,
      oldModeratelyEngaged: 0,
      somewhatEngaged: 0,
      oldSomewhatEngaged: 0,
      notEngaged: 0,
      oldNotEngaged: 0,
    },
    directReportsEngagedData: [],
    directReports1: {},
    dailyContributions:'',
    youFeeling:[],
    teamFeeling:[],
    feeling:{good: 0,okay: 0,critical: 0},
    loading: true,
    userDetail:{},
    performingData:[],
    userCardData:{},
    directReportsCardData:[],
    growingData: {},
    loadingStatus: false,
    talentTeam:{},
    loadingProgress:0,
    holiday:[],
    dailyData:[],
    alldays:false,
    month:[],
    consistent:'',
    companyCreatedate:''
    
  },
  mutations: {
    setTeam(state: any, result: any) {
      state.team = result
    },
    setEngagement(state: any, result: any) {
      state.engagement = result
    },
    setdirectReports(state: any, result: any) {
      state.directReports = result
    },
    setloading(state: any, result: any) {
      state.loading = result
    },
    setFeeling(state:any, result:any) {
      state.feeling = result
    },
    setPartTalentTeam(state:any, result:any) {
           
      state.directReportsCardData = result
  },
    setDirectReportsEngagedValue(state: any, result: any) {
      state.directReportsEngagedValue = result
    },
    setDirectReportsEngagedData(state: any, result: any) {
      state.directReportsEngagedData = result
    },
    setDirectReportsLoading(state: any, result: any) {
      state.directReportsLoading = result
    },
    setuserDetail(state: any, result: any) {
        state.userDetail = result
      },
    setContributions(state:any, result:any) {
        state.dailyContributions = result
    },
    setYouFeeling(state:any, result:any) {
      state.youFeeling = result
  },
  setTeamFeeling(state:any, result:any) {
    state.teamFeeling = result
  },
  setPerformingData(state:any, result:any) {
    state.performingData = result
  },
  setuserCardData(state: any, value: any) {
    state.userCardData = value
  },
  setGrowingData(state:any, result:any) {
    state.growingData = result
},
setTalentTeam(state:any, result:any) {
  state.talentTeam = result
},
setloadingStatus(state: any, value: any) {
  state.loadingStatus = value
},
setLoadingProgress(state: any, value: any) {
  state.loadingProgress = value
},
setdailyData(state: any, value: any) {
    state.dailyData = value
},
setConsistent(state: any, value: any) {
    state.consistent = value
}

  },
  actions: {

    async getTeam({ commit, dispatch, rootState, state ,getters}: any, value: any) {
      // getTeam ถูก dispatch จาก .vue — กัน race: ถ้า user ยังไม่พร้อม (ไม่มี company) ให้ข้าม
      // และ sign in ก่อนอ่าน /company (กัน permission_denied ถ้า session ยังไม่พร้อม)
      await ensureReportAuth()
      if (!value || !value.company) return
      const allUserKey ={}
      commit("setLoadingProgress",state.loadingProgress+10)
      const company = (await firebase.database().ref(`/company/${value.company}`).once('value')).val()

      state.companyCreatedate=company.createdate
      state.alldays=company.alldays?company.alldays:false
      const _usersByCompany = await getUsersByCompany(value.company)
      Object.values(_usersByCompany).forEach((childData:any) => {
            let _data = childData;
            const emailKey = _data.email.replace(/\./g, '||')
            if(rootState.monthlyInsignhts.teamAll[_data.team]){
                    allUserKey[emailKey]=_data
            }
      })
      commit('setTeam', allUserKey)
      dispatch('getDailyData360',value)
      dispatch('getuserDetail',value)
      dispatch('getReportMonthly',value)
      
      
      
    },
    getuserDetail({ commit, dispatch, rootState, state }: any, value: any){
            
      let pastMonth = value.num_month - 1;
      let year = parseInt(format(value.year, "YYYY"));
      let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
      var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
      var talentTeam={}
      fetchTalentAndNetwork({
        date: value.year+'-'+value.num_month+'-'+lastDayOfMonth,
        company: value.company,
        email: value.email,
      })
      .then(function (response) {
        const data = response.data
        // console.log("data",response.data)//JSON.stringify(response.data));
                let userDetail={
                  totalConnections: data.network?data.network.node_count_total:0,
                  innerNetwork:data.network?data.network.node_count_inner:0,
                  newInnerNetwork: data.network?data.network.node_new_inner:0,
                  outerNetwork: data.network?data.network.node_count_outer:0,
                  newOuterNetwork: data.network?data.network.node_new_outer:0,
              }
          data.talent.map(value=>{
            const emailKey = value.email.replace(/\./g, '||')
            talentTeam[emailKey]=value.talent_before
          })
          commit('setTalentTeam',talentTeam)
          commit('setuserDetail',userDetail)
      })
      .catch(function (error) {
        console.log(error);
      });
  },
    getReportMonthly({ commit, dispatch, rootState, state }: any, value: any){
      commit("setloadingStatus",true)
      commit("setLoadingProgress",state.loadingProgress+15)

    var _directReports= {
        engagedFocus: 0,
        engagedFocusType: "highlyEngaged",
        engagedValue: {
          // superEngaged: 0,
          // oldSuperEngaged: 0,
          highlyEngaged: 0,
          oldHighlyEngaged: 0,
          moderatelyEngaged: 0,
          oldModeratelyEngaged: 0,
          somewhatEngaged: 0,
          oldSomewhatEngaged: 0,
          notEngaged: 0,
          oldNotEngaged: 0,
          inActive:0,
          oldInActive:0
        },
        engagedData: [],
      }
    
    commit("setdirectReports",_directReports)
      let performingData:Array<any>=[]
      var PersonalGrowth:any={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Recognition:any={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Rel_Colleagues:any={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Satisfaction:any={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Ambassadorship:any={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Feedback:any={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Wellness:any={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Company_Alignment:any={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      var Rel_Manager:any={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
      let month = parseInt(value.num_month);
      let pastMonth = month - 1;
      let year = parseInt(format(value.year, "YYYY"));
      let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
      var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
      var status_feeling={good: 0,okay: 0,critical: 0}
      const start_date = value.year + "-" + value.num_month 
      const lastDate=value.year + "-" + value.num_month+"-"+"31" 
      let feeling: Array<any>=[];
      let end_date  = format(subMonths(start_date, 1), 'YYYY-MM')
      let OldtalentTeam=state.talentTeam
      var _engagement={}
      let engagedData : Array<any> = [];
      var data_Contribution={}
      let engagement={
        challenges: {
          dailyCheck: "",
          peerFeedback: "",
          feedback: "",
          happilyVillage: "",
          superFeedback: "",
          rewards: "",
          recognition: "",
          favoritedSparks: "",
          superRecognition: "",
          NetworkBuilding: "",
        },
      }
      let directReports: Array<any>=[
        {name: "Untapped Potential",value: 0},
        {name: "Activated",value: 0},
        {name: "High Performer",value: 0},
        {name: "Superstar",value: 0},

        {name: "Valued Contributor",value: 0},
        {name: "Key Player",value: 0},
        {name: "Respected Expert",value: 0},
        {name: "Distinguished Talent",value: 0},

        {name: "Community Pillar",value: 0},
        {name: "Engaged Contributor",value: 0},
        {name: "Core Player",value: 0},
        {name: "Solid Performer",value: 0},

        {name: "Up-and-Coming",value: 0},
        {name: "Rising Star",value: 0},
        {name: "Emerging Talent",value: 0},
        {name: "High Potential",value: 0},

        {name: "Latent Potential",value: 0},
        {name: "Contributor",value: 0},
        {name: "Crowd Favorite",value: 0},
        {name: "Unsung Talent",value: 0},
        // {name: "Untapped Potential",value: 0},
        // {name: "Activated",value: 0},
        // {name: "High Performer",value: 0},
        // {name: "Superstar",value: 0},
        // {name: "Community Pillar",value: 0},
        // {name: "Engaged Contributor",value: 0}, 
        // {name: "Core Player",value: 0},
        // {name: "Solid Performer",value: 0},
        // {name: "Up-and-coming", value: 0},
        // {name: "Rising Star",value: 0},
        // {name: "Emerging Talent",value: 0},
        // {name: "High Potential",value: 0},
        // {name: "Latent Potential",value: 0},
        // {name: "Contributor",value: 0},
        // {name: "Crowd Favorite",value: 0},
        // {name: "Unsung Talent",value: 0},
      ]
      const allUserKey = state.team
      let growingTeam: Array<any> = [];
      let holiday: Array<any> = [];
      let youFeeling: Array<any>=[];
      let team: { [key: string]: any } = {};
      let _team: Array<any> = [];
      let userCardData: any = {};
      let talentClass: any = '';
      let networkClass: any = '';
      let trulyClass: any = '';
      let starClass: any = '';
      let engagementClass: any = ''; 
      let checkPeople=true
      let talentTeam: { [key: string]: any } = {};
      let users_sleep_steps: { [key: string]: any } = {};
      const skillMaster={      
        "ps_leadership":'l',
        "ps_self_awareness":'s',
        "ps_optimism":'o',
        "ps_critical_thinking":'c',
        "ps_empathy":'e',
        "ps_initiative_making":'i'
      }

        firebase.database().ref('team').once('value', (snapshot) => {
          snapshot.forEach((childSnapshot) => {
              let _data = childSnapshot.val();
              _team.push({..._data,key:childSnapshot.key})
              
          })
          team= _.groupBy(_team, function (b) { return b.key })
        
        })
        firebase.firestore().collection('/holliday').where('companyid','==',value.company).where('date','>=',`${start_date}-01`).where('date','<=',lastDate).get().then((querySnapshot)=>{
          querySnapshot.forEach((doc) => {
              const data=doc.data()
              holiday.push(data)        
          })
       
      })
      firebase.firestore().collection('users_sleep_steps').where('email', '==', value.email).where('date','>=',`${start_date}-01`).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            const data = doc.data()
            if(!users_sleep_steps[data.date]){
              users_sleep_steps[data.date]={steps:data.steps,sleep:data.sleep}
            }
        })
      })
  
      firebase.firestore().collection('report_monthly').where('company', '==', value.company).where("monthyear", "in", [start_date, end_date]).get().then( async (querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            //const emailKey = data.email.replace(/\./g, '||')
            if(!_engagement[data.email+"-"+data.monthyear]){
              _engagement[data.email+"-"+data.monthyear]={}
            }
            _engagement[data.email+"-"+data.monthyear]=data
          })
          commit("setLoadingProgress",state.loadingProgress+15)

          for (const user in allUserKey) {

            let engagementKey: Array<any> = []
            let engagedType: string = ''
            let engagedSort=0

            var result:Array<any>=[]
            let medalCount:any=0
            if(_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].medal){
              _.forEach(_engagement[allUserKey[user].email+"-"+start_date].medal, (value,key)=> { 
                medalCount += value
              });
            }
            
            if(_engagement[allUserKey[user].email+"-"+start_date]!==undefined){
            for (const excel in _engagement[allUserKey[user].email+"-"+start_date].excels) {
              let data={name:excel,value:_engagement[allUserKey[user].email+"-"+start_date].excels[excel]}
              result.push(data)
            }
          }

            if(talentTeam[allUserKey[user].talent]!=undefined)
            {
                talentTeam[allUserKey[user].talent]++
            }else {
                talentTeam[allUserKey[user].talent]=1
            }

            if(_engagement[allUserKey[user].email+"-"+start_date]){
            //======current=======
          //   if (_engagement[allUserKey[user].email+"-"+start_date].daily_color === 'green' &&
          //   _engagement[allUserKey[user].email+"-"+start_date].feedback_color === 'green' &&
          //   _engagement[allUserKey[user].email+"-"+start_date].super_feedback_color === 'green' &&
          //   _engagement[allUserKey[user].email+"-"+start_date].recognition_color=== 'green' &&
          //   _engagement[allUserKey[user].email+"-"+start_date].super_recognition_color === 'green' &&
          //   _engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color === 'green' &&
          //   _engagement[allUserKey[user].email+"-"+start_date].happily_village_color === 'green' &&
          //   _engagement[allUserKey[user].email+"-"+start_date].favorite_spark_color === 'green' ) {
          //   engagedType = "superEngaged"
          //   engagedSort=1
            
          //   state.directReports.engagedValue.superEngaged++

          // }
          if(!_engagement[allUserKey[user].email+"-"+start_date].daily_answer){
            engagedType = "inActive"
            engagedSort=6
            state.directReports.engagedValue.inActive++
            engagementClass='a'
          }
          else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color === 'green' &&
            _engagement[allUserKey[user].email+"-"+start_date].feedback_color === 'green' &&
            _engagement[allUserKey[user].email+"-"+start_date].super_feedback_color !== 'red' &&
            _engagement[allUserKey[user].email+"-"+start_date].recognition_color === 'green' &&
            _engagement[allUserKey[user].email+"-"+start_date].super_recognition_color !== 'red' &&
            _engagement[allUserKey[user].email+"-"+start_date].happily_village_color !== 'red' &&
            _engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color === 'green' ) {
            engagedType = "highlyEngaged"
            engagedSort=2
            engagementClass='d'
            state.directReports.engagedValue.highlyEngaged++

          } else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color === 'green' &&
            _engagement[allUserKey[user].email+"-"+start_date].feedback_color !== 'red' &&
            _engagement[allUserKey[user].email+"-"+start_date].recognition_color !== 'red') {
            engagedType = "moderatelyEngaged"
            engagedSort=3
            state.directReports.engagedValue.moderatelyEngaged++
            engagementClass='c'
          } else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color !== 'red') {
            engagedType = "somewhatEngaged"
            engagedSort=4
            engagementClass='b'
            state.directReports.engagedValue.somewhatEngaged++

          } else {
            engagedType = "underEngaged"
            engagedSort=5
            engagementClass='a'
            state.directReports.engagedValue.notEngaged++

          }
        }
      
          // console.log("allUserKey[user].email",allUserKey[user].email)
          // console.log("daily_color", _engagement[allUserKey[user].email+"-"+start_date].daily_color)
          // console.log("feedback_color", _engagement[allUserKey[user].email+"-"+start_date].feedback_color)
          // console.log("super_feedback_color", _engagement[allUserKey[user].email+"-"+start_date].super_feedback_color)
          // console.log("recognition_color", _engagement[allUserKey[user].email+"-"+start_date].recognition_color)
          // console.log("super_recognition_color", _engagement[allUserKey[user].email+"-"+start_date].super_recognition_color)
          // console.log("peerfeedback_color", _engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color)
          // console.log("happily_village_color", _engagement[allUserKey[user].email+"-"+start_date].happily_village_color)
          // console.log("favorite_spark_color", _engagement[allUserKey[user].email+"-"+start_date].favorite_spark_color)
          // console.log("networkbulding_color", _engagement[allUserKey[user].email+"-"+start_date].networkbulding_color)
          // console.log("engagedType",engagedType)
          if(_engagement[allUserKey[user].email+"-"+end_date]){
          //======old=======
        //   if (_engagement[allUserKey[user].email+"-"+end_date].daily_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].feedback_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].super_feedback_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].recognition_color=== 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].super_recognition_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].peerfeedback_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].happily_village_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+end_date].favorite_spark_color === 'green' ) {
          
        //   state.directReports.engagedValue.oldSuperEngaged++
            

        // } 
        if(!_engagement[allUserKey[user].email+"-"+end_date].daily_answer){
        
          state.directReports.engagedValue.oldInActive++
        }
        else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color === 'green' &&
          _engagement[allUserKey[user].email+"-"+end_date].feedback_color === 'green' &&
          _engagement[allUserKey[user].email+"-"+end_date].super_feedback_color !== 'red' &&
          _engagement[allUserKey[user].email+"-"+end_date].recognition_color === 'green' &&
          _engagement[allUserKey[user].email+"-"+end_date].super_recognition_color !== 'red' &&
          _engagement[allUserKey[user].email+"-"+end_date].happily_village_color !== 'red' &&
          _engagement[allUserKey[user].email+"-"+end_date].peerfeedback_color === 'green' ) {
          
          state.directReports.engagedValue.oldHighlyEngaged++
            

        } else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color === 'green' &&
          _engagement[allUserKey[user].email+"-"+end_date].feedback_color !== 'red' &&
          _engagement[allUserKey[user].email+"-"+end_date].recognition_color !== 'red' ) {
            
          state.directReports.engagedValue.oldModeratelyEngaged++
            

        } else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color !== 'red') {
        
          state.directReports.engagedValue.oldSomewhatEngaged++
          
        } else {
        
          state.directReports.engagedValue.oldNotEngaged++
          

        }
      }
      
      var networkbulding_color=""
      if((state.userDetail.newInnerNetwork+state.userDetail.newOuterNetwork)>0){
        networkbulding_color="green"
      }
      else{
        networkbulding_color="red"
      }
      // console.log("allUserKey[user].email",state.directReports.engagedValue)
            if(allUserKey[user].email==value.email){
              checkPeople=false
              var redeem_rewards_color=""
              if(_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].redeem_rewards_count>=1)
              {
                redeem_rewards_color="green"
              }else {
                redeem_rewards_color="red"
              }
              if(_engagement[allUserKey[user].email+"-"+start_date]){
              engagement.challenges.dailyCheck=_engagement[allUserKey[user].email+"-"+start_date].daily_color
              engagement.challenges.peerFeedback=_engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color
              engagement.challenges.feedback=_engagement[allUserKey[user].email+"-"+start_date].feedback_color
              engagement.challenges.happilyVillage=_engagement[allUserKey[user].email+"-"+start_date].happily_village_color
              engagement.challenges.superFeedback=_engagement[allUserKey[user].email+"-"+start_date].super_feedback_color
              engagement.challenges.rewards=redeem_rewards_color//_engagement[allUserKey[user].email+"-"+start_date].redeem_rewards_color
              engagement.challenges.recognition=_engagement[allUserKey[user].email+"-"+start_date].recognition_color
              engagement.challenges.favoritedSparks=_engagement[allUserKey[user].email+"-"+start_date].favorite_spark_color
              engagement.challenges.superRecognition=_engagement[allUserKey[user].email+"-"+start_date].super_recognition_color
              engagement.challenges.NetworkBuilding=networkbulding_color//_engagement[allUserKey[user].email+"-"+start_date].networkbulding_color
              let sortNot_good = _.sortBy(_engagement[allUserKey[user].email+"-"+start_date].report_card_notgood, [function (o: any) { return o.priority; }])
              let good=_engagement[allUserKey[user].email+"-"+start_date].report_card_good
              if(sortNot_good.length==0){
                engagementKey.push(good + " viewpoints that are positive & healthy")
              }else if(sortNot_good.length==1){
                engagementKey.push(sortNot_good[0].text, `${good} viewpoints that are positive & healthy`)
              }else{
                engagementKey.push(sortNot_good[0].text, sortNot_good[1].text, `${good} viewpoints that are positive & healthy`)
              }
              let setData = {
                name: allUserKey[user].firstname + " " + allUserKey[user].lastname,
                firstname: allUserKey[user].firstname,
                lastname: allUserKey[user].lastname,
                image: allUserKey[user].profilepic,
                teamName: team[allUserKey[user].team]?team[allUserKey[user].team][0].name:"",
                engagedType: engagedType,
                engagementKey: engagementKey,
                sort:engagedSort
              }
              
              engagedData.push(setData)


              //====setContributions====//
              data_Contribution={
                dailyAttendance:_engagement[allUserKey[user].email+"-"+start_date].daily,
                dailyAttendanceStatus:_engagement[allUserKey[user].email+"-"+start_date].daily_color,
                feedbackShared:_engagement[allUserKey[user].email+"-"+start_date].feedback,
                feedbackSharedStatus: _engagement[allUserKey[user].email+"-"+start_date].feedback_color,
                managerReplyRate:_engagement[allUserKey[user].email+"-"+start_date].replyrate?_engagement[allUserKey[user].email+"-"+start_date].replyrate:'',
                managerReplyRateStatus:_engagement[allUserKey[user].email+"-"+start_date].replyrate_color?_engagement[allUserKey[user].email+"-"+start_date].replyrate_color:'',
                insightsOpened:_engagement[allUserKey[user].email+"-"+start_date].insight?(((_engagement[allUserKey[user].email+"-"+start_date].insight*100)>100)?100:_engagement[allUserKey[user].email+"-"+start_date].insight*100):"",
                insightsOpenedStatus:_engagement[allUserKey[user].email+"-"+start_date].insight_color?_engagement[allUserKey[user].email+"-"+start_date].insight_color:"",
                recognitionGiven:_engagement[allUserKey[user].email+"-"+start_date].recognition,
                recognitionGivenStatus:_engagement[allUserKey[user].email+"-"+start_date].recognition_color,
                peerFeedback: _engagement[allUserKey[user].email+"-"+start_date].peerfeedback,
                peerFeedbackStatus: _engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color,
                
            }
          
            ///===you feeling====
            for(let j=0;j<lastDayOfMonth;j++){
              const day=(j+1)<10?"0"+(j+1):(j+1)
              const date=value.year+"-"+value.num_month+"-"+day
              let weekend = format(date, "dd");
              let skill=''
              let steps:any=''
              let sleep:any=''
              if(_engagement[allUserKey[user].email+"-"+start_date].power_skill&&_engagement[allUserKey[user].email+"-"+start_date].power_skill[date]){
                for(const key in _engagement[allUserKey[user].email+"-"+start_date].power_skill[date]){
                  if(_engagement[allUserKey[user].email+"-"+start_date].power_skill[date][key].skip){
                    skill="skip"
                  }else if(_engagement[allUserKey[user].email+"-"+start_date].power_skill[date][key].answer){
                    skill=skillMaster[key]
                  }
                }
               
              }
              if(users_sleep_steps[date]){
                steps=users_sleep_steps[date].steps?users_sleep_steps[date].steps>5000?'1':'0':''
                sleep=users_sleep_steps[date].sleep?users_sleep_steps[date].sleep/60>=7?'1':'0':''
              }
              if(weekend!=="Su"&&weekend!=="Sa"){
              var _holiday = _.find(holiday, function(value){
                  return value != null && value.date == date;
                });
                  if(j==0){
                      let dayLabel = format(date, "d");
                      
                      for(let i=1;i<parseInt(dayLabel);i++){
                         youFeeling.push("no_ring.png")
                         // youFeeling.push("#DBDBDB")
                          
                      }
                      
                  }
                if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer&&!_holiday){
                
                  if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer[date]&&!_holiday){
                    
                    if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer[date]==="green"){
                          //youFeeling.push("#27BC6C")
                          const img =await dispatch('getRingImage',{reflection:'g',skill:skill,movement:steps,sleep:sleep})
                          youFeeling.push(img)
                          if(!value.boss){
                            status_feeling.good++
                          }
                    }else if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer[date]==="yellow"){
            
                        const img =await dispatch('getRingImage',{reflection:'y',skill:skill,movement:steps,sleep:sleep})
                        youFeeling.push(img)
                      //youFeeling.push("#FFBA0D")
                          if(!value.boss){
                            status_feeling.okay++
                          }
                    }else if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer[date]==="red"){
                         const img =await dispatch('getRingImage',{reflection:'r',skill:skill,movement:steps,sleep:sleep})
                         youFeeling.push(img)
                          //youFeeling.push("#F22F3C")
                          if(!value.boss){
                            status_feeling.critical++
                          }
                      
                    }else{
                      const img =await dispatch('getRingImage',{reflection:'',skill:skill,movement:steps,sleep:sleep})
                      youFeeling.push(img) 
                    
                      //youFeeling.push("#7B7B7B")
                    }
                  }else{
                      if(_holiday){
                          const img =await dispatch('getRingImage',{reflection:'h',skill:skill,movement:steps,sleep:sleep})
                          youFeeling.push(img) 
                     
                          // youFeeling.push("#DBDBDB")
                          
                      }else{
                          const img =await dispatch('getRingImage',{reflection:'',skill:skill,movement:steps,sleep:sleep})
                          youFeeling.push(img) 
        
                          //youFeeling.push("#7B7B7B")
                          
                      }
                  }
                }else{
                  if(_holiday){
                    const img =await dispatch('getRingImage',{reflection:'h',skill:skill,movement:steps,sleep:sleep})
                    youFeeling.push(img)

                    //youFeeling.push("#DBDBDB")
                    
                }else{
                    const img =await dispatch('getRingImage',{reflection:'',skill:skill,movement:steps,sleep:sleep})
                   youFeeling.push(img) 
       
                    //youFeeling.push("#7B7B7B")
                    
                }

                }
              }
            
              if(j==lastDayOfMonth-1)
              {
                  
                  if(youFeeling.length<25){
                      for(let i=youFeeling.length;i<25;i++)
                      {
                         youFeeling.push("no_ring.png")
                         
                         // youFeeling.push("#DBDBDB")
                        
                          
                          
                      }
                      
                  }

              }
              
            }
              
            if(!value.boss){
              
              commit('setFeeling', status_feeling)
            }
  
            if(value.boss){
              if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager){
                ///===team feeling====
                for(let j=0;j<lastDayOfMonth;j++){
                  const day=(j+1)<10?"0"+(j+1):(j+1)
                  const date=value.year+"-"+value.num_month+"-"+day
                  let weekend = format(date, "dd");
                
                  if(weekend!=="Su"&&weekend!=="Sa"){
                  var _holiday = _.find(holiday, function(value){
                      return value != null && value.date == date;
                    });
                      if(j==0){
                          let dayLabel = format(date, "d");
                          
                          for(let i=1;i<parseInt(dayLabel);i++){
                            feeling.push("#C4C4C4")
            
                              
                          }
                          
                      }
                      if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]&&!_holiday){
                        if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="green"){
                          feeling.push("#27BC6C")
                              status_feeling.good++
                        }else if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="yellow"){
                          feeling.push("#FFBA0D")
                              status_feeling.okay++
                        }else if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="red"){
                          feeling.push("#F22F3C")
                          status_feeling.critical++
                        }else{
                          feeling.push("#7B7B7B")
                        }
                      }else{
                          if(_holiday){
                            feeling.push("#C4C4C4")
                              
                          }else{
                            feeling.push("#7B7B7B")
                              
                          }
                      }
                  }
                  if(j==lastDayOfMonth-1)
                  {
                      
                      if(feeling.length<25){
                          for(let i=feeling.length;i<25;i++)
                          {
                            feeling.push("#C4C4C4")
                              
                          }
                          
                      }
      
                  }
                  
              }
            }else{
              for(let i=feeling.length;i<25;i++)
              {

                feeling.push("#7B7B7B")
              }

            }

                  commit('setFeeling', status_feeling)
                  commit('setTeamFeeling', feeling)
                  
      
            }
          }

            if(!value.boss){

              PersonalGrowth={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
              Recognition={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
              Rel_Colleagues={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
              Satisfaction={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
              Ambassadorship={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
              Feedback={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
              Wellness={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
              Company_Alignment={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
              Rel_Manager={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}

            }
            if(_engagement[allUserKey[user].email+"-"+start_date]){
              if(_engagement[allUserKey[user].email+"-"+start_date].dimensions){
              PersonalGrowth.value=PersonalGrowth.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth.value:0)
              Recognition.value=Recognition.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition.value:0)
              Rel_Colleagues.value=Rel_Colleagues.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues.value:0)
              Satisfaction.value=Satisfaction.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction.value:0)
              Ambassadorship.value=Ambassadorship.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship.value:0)
              Feedback.value=Feedback.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback.value:0)
              Rel_Manager.value=Rel_Manager.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager.value:0)
              Wellness.value=Wellness.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness.value:0)
              Company_Alignment.value=Company_Alignment.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment.value:0)


              PersonalGrowth.total=PersonalGrowth.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth.total:0)
              Recognition.total=Recognition.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition.total:0)
              Rel_Colleagues.total=Rel_Colleagues.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues.total:0)
              Satisfaction.total=Satisfaction.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction.total:0)
              Ambassadorship.total=Ambassadorship.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship.total:0)
              Feedback.total=Feedback.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback.total:0)
              Rel_Manager.total=Rel_Manager.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager.total:0)
              Wellness.total=Wellness.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness.total:0)
              Company_Alignment.total=Company_Alignment.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment.total:0)
              }
            }
  
            if(_engagement[allUserKey[user].email+"-"+end_date]){
              if(_engagement[allUserKey[user].email+"-"+end_date].dimensions){
              // //====old=====
              PersonalGrowth.previous_value=PersonalGrowth.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth.value:0)
              Recognition.previous_value=Recognition.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition.value:0)
              Rel_Colleagues.previous_value=Rel_Colleagues.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues.value:0)
              Satisfaction.previous_value=Satisfaction.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction.value:0)
              Ambassadorship.previous_value=Ambassadorship.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship.value:0)
              Feedback.previous_value=Feedback.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback.value:0)
              Rel_Manager.previous_value=Rel_Manager.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager.value:0)
              Wellness.previous_value=Wellness.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness.value:0)
              Company_Alignment.previous_value=Company_Alignment.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment.value:0)


              PersonalGrowth.previous_total=PersonalGrowth.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth.total:0)
              Recognition.previous_total=Recognition.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition.total:0)
              Rel_Colleagues.previous_total=Rel_Colleagues.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues.total:0)
              Satisfaction.previous_total=Satisfaction.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction.total:0)
              Ambassadorship.previous_total=Ambassadorship.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship.total:0)
              Feedback.previous_total=Feedback.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback.total:0)
              Rel_Manager.previous_total=Rel_Manager.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager.total:0)
              Wellness.previous_total=Wellness.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness.total:0)
              Company_Alignment.previous_total=Company_Alignment.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment.total:0)
              }
            }
            if(!value.boss){
              PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
              Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
              Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
              Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
              Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
              Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
              Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
              Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
              Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));
    
              PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
              PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
              performingData.push(PersonalGrowth)
              Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
              Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
              performingData.push(Recognition)
              Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
              Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
              performingData.push(Rel_Colleagues)
              Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
              Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
              performingData.push(Satisfaction)
              Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
              Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
              performingData.push(Ambassadorship)
              Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
              Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
              performingData.push(Feedback)
              Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
              Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
              performingData.push(Rel_Manager)
              Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
              Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
              performingData.push(Wellness)
              Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
              Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
              performingData.push(Company_Alignment)
                let _performingData =_.orderBy(performingData, ['calulate'], ['desc'])
                commit('setPerformingData', _performingData)
            
            }
            if(_engagement[allUserKey[user].email+"-"+start_date]){
            if(_engagement[allUserKey[user].email+"-"+start_date].talent=='Latent Potential'){
              talentClass='a'

            }else if(_engagement[allUserKey[user].email+"-"+start_date].talent=='Up-and-coming'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Contributor'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Community Pillar'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Rising Star'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Crowd Favorite'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Untapped Potential'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Engaged Contributor'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Emerging Talent'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Unsung Talent'){
              talentClass='b'
            }
            else if(_engagement[allUserKey[user].email+"-"+start_date].talent=='Activated'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Core Player'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='High Potential'){
              talentClass='c'
            }
            else if(_engagement[allUserKey[user].email+"-"+start_date].talent=='High Performer'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Solid Performer'||
            _engagement[allUserKey[user].email+"-"+start_date].talent=='Superstar'){
              talentClass='d'
            }


            
            if(_engagement[allUserKey[user].email+"-"+start_date].network_type=='Low Network'||
            _engagement[allUserKey[user].email+"-"+start_date].network_type=='Medium Outer'||
            _engagement[allUserKey[user].email+"-"+start_date].network_type=='Medium Inner'){
              networkClass='a'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].network_type=='Medium Network'||
            _engagement[allUserKey[user].email+"-"+start_date].network_type=='High Outer'||
            _engagement[allUserKey[user].email+"-"+start_date].network_type=='High Inner'){
              networkClass='b'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].network_type=='High Network'||
            _engagement[allUserKey[user].email+"-"+start_date].network_type=='Super Outer'||
            _engagement[allUserKey[user].email+"-"+start_date].network_type=='Super Inner'){
              networkClass='c'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].network_type=='Super Network'){
              networkClass='d'
            }
            if(_engagement[allUserKey[user].email+"-"+start_date].truly>=4){
              trulyClass='d'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].truly>=2&&_engagement[allUserKey[user].email+"-"+start_date].truly<=3){
              trulyClass='c'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].truly==1){
              trulyClass='b'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].truly<=0){
              trulyClass='a'
            }

            if(_engagement[allUserKey[user].email+"-"+start_date].star>=6){
              starClass='d'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].star>=4&&_engagement[allUserKey[user].email+"-"+start_date].star<=5){
              starClass='c'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].star>=1&&_engagement[allUserKey[user].email+"-"+start_date].star<=3){
              starClass='b'
            }else if(_engagement[allUserKey[user].email+"-"+start_date].star<=0){
              starClass='a'
            }

            }
            userCardData={
              name: (allUserKey[user].firstname+" "+allUserKey[user].lastname.slice(0, 1)),
              firstname: allUserKey[user].firstname,
              lastname: allUserKey[user].lastname,
              image:allUserKey[user].profilepic,
              talentChanged:OldtalentTeam[user]?(allUserKey[user].talent===OldtalentTeam[user]?true:false):false, 
              email:allUserKey[user].email,
              starPerformer:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].star?_engagement[allUserKey[user].email+"-"+start_date].star:0,
              talent:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].talent=="Marginalized"?"Starter":(_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].talent=="Hidden Talent"?"Hidden Gem":(_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].talent?_engagement[allUserKey[user].email+"-"+start_date].talent:"-")),
              oldTalent:OldtalentTeam[user]?OldtalentTeam[user]=="Marginalized"?"Starter":(OldtalentTeam[user]=="Hidden Talent"?"Hidden Gem":OldtalentTeam[user]):"",
              excelsAt:result,
              outstanding:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].truly?_engagement[allUserKey[user].email+"-"+start_date].truly:0,
              impact_rating:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].impact_rating?(_engagement[allUserKey[user].email+"-"+start_date].impact_rating*1.0).toFixed(1):0,
              impact_rating_lastweek:_engagement[allUserKey[user].email+"-"+end_date]&&_engagement[allUserKey[user].email+"-"+end_date].impact_rating?(_engagement[allUserKey[user].email+"-"+end_date].impact_rating*1.0).toFixed(1):0,
              impact_rating_change:((_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].impact_rating?(_engagement[allUserKey[user].email+"-"+start_date].impact_rating*1.0):0)-(_engagement[allUserKey[user].email+"-"+end_date]&&_engagement[allUserKey[user].email+"-"+end_date].impact_rating?(_engagement[allUserKey[user].email+"-"+end_date].impact_rating*1.0):0)).toFixed(1),
              network_type:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].network_type?_engagement[allUserKey[user].email+"-"+start_date].network_type:"-",  
              engagedType: engagedType,
              medalCount:medalCount,
              truly:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].truly?_engagement[allUserKey[user].email+"-"+start_date].truly:0, 
              star: _engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].star?_engagement[allUserKey[user].email+"-"+start_date].star:0,
              engagementClass:engagementClass,
              talentClass:talentClass,
              networkClass:networkClass,
              trulyClass:trulyClass,
              starClass:starClass
          }

          commit('setuserCardData', userCardData)
          commit('setYouFeeling', youFeeling)
          commit('setContributions', data_Contribution)
          commit("setEngagement",{...engagement,engagementKey:engagementKey,engagementType:engagedType})

            }else{
            
              if(_engagement[allUserKey[user].email+"-"+start_date]){
              if(_engagement[allUserKey[user].email+"-"+start_date].dimensions){
              // console.log("dimensions",allUserKey[user].email,_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship)
              PersonalGrowth.value=PersonalGrowth.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth.value:0)
              Recognition.value=Recognition.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition.value:0)
              Rel_Colleagues.value=Rel_Colleagues.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues.value:0)
              Satisfaction.value=Satisfaction.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction.value:0)
              Ambassadorship.value=Ambassadorship.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship.value:0)
              Feedback.value=Feedback.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback.value:0)
              Rel_Manager.value=Rel_Manager.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager.value:0)
              Wellness.value=Wellness.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness.value:0)
              Company_Alignment.value=Company_Alignment.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment.value:0)


              PersonalGrowth.total=PersonalGrowth.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth.total:0)
              Recognition.total=Recognition.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition.total:0)
              Rel_Colleagues.total=Rel_Colleagues.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues.total:0)
              Satisfaction.total=Satisfaction.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction.total:0)
              Ambassadorship.total=Ambassadorship.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship.total:0)
              Feedback.total=Feedback.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback.total:0)
              Rel_Manager.total=Rel_Manager.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager.total:0)
              Wellness.total=Wellness.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness.total:0)
              Company_Alignment.total=Company_Alignment.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment.total:0)
              }
            }
            if(_engagement[allUserKey[user].email+"-"+end_date]){
              if(_engagement[allUserKey[user].email+"-"+end_date].dimensions){
              // //====old=====
              PersonalGrowth.previous_value=PersonalGrowth.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth.value:0)
              Recognition.previous_value=Recognition.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition.value:0)
              Rel_Colleagues.previous_value=Rel_Colleagues.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues.value:0)
              Satisfaction.previous_value=Satisfaction.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction.value:0)
              Ambassadorship.previous_value=Ambassadorship.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship.value:0)
              Feedback.previous_value=Feedback.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback.value:0)
              Rel_Manager.previous_value=Rel_Manager.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager.value:0)
              Wellness.previous_value=Wellness.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness.value:0)
              Company_Alignment.previous_value=Company_Alignment.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment.value:0)


              PersonalGrowth.previous_total=PersonalGrowth.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth.total:0)
              Recognition.previous_total=Recognition.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition.total:0)
              Rel_Colleagues.previous_total=Rel_Colleagues.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues.total:0)
              Satisfaction.previous_total=Satisfaction.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction.total:0)
              Ambassadorship.previous_total=Ambassadorship.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship.total:0)
              Feedback.previous_total=Feedback.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback.total:0)
              Rel_Manager.previous_total=Rel_Manager.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager.total:0)
              Wellness.previous_total=Wellness.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness.total:0)
              Company_Alignment.previous_total=Company_Alignment.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment.total:0)
              }
              }

        if(_engagement[allUserKey[user].email+"-"+start_date]){
            let sortNot_good = _.sortBy(_engagement[allUserKey[user].email+"-"+start_date].report_card_notgood, [function (o: any) { return o.priority; }])
            let good=_engagement[allUserKey[user].email+"-"+start_date].report_card_good
            if(sortNot_good.length==0){
              engagementKey.push(good + " viewpoints that are positive & healthy")
            }else if(sortNot_good.length==1){
              engagementKey.push(sortNot_good[0].text, `${good} viewpoints that are positive & healthy`)
            }else{
              engagementKey.push(sortNot_good[0].text, sortNot_good[1].text, `${good} viewpoints that are positive & healthy`)
            }
          
            let setData = {
              name: allUserKey[user].firstname + " " + allUserKey[user].lastname,
              firstname: allUserKey[user].firstname,
              lastname: allUserKey[user].lastname,
              image: allUserKey[user].profilepic,
              teamName: team[allUserKey[user].team]?team[allUserKey[user].team][0].name:"",
              engagedType: engagedType,
              engagementKey: engagementKey,
              sort:engagedSort
            }
            
            engagedData.push(setData)
          
            growingTeam.push({
              name: (allUserKey[user].firstname+" "+allUserKey[user].lastname.slice(0, 1)),
              firstname: allUserKey[user].firstname,
              lastname: allUserKey[user].lastname,
              image:allUserKey[user].profilepic,
              talentChanged:OldtalentTeam[user]?(allUserKey[user].talent===OldtalentTeam[user]?true:false):false, 
              email:allUserKey[user].email,
              starPerformer:_engagement[allUserKey[user].email+"-"+start_date].star,
              talent:_engagement[allUserKey[user].email+"-"+start_date].talent=="Marginalized"?"Starter":(_engagement[allUserKey[user].email+"-"+start_date].talent=="Hidden Talent"?"Hidden Gem":(_engagement[allUserKey[user].email+"-"+start_date].talent?_engagement[allUserKey[user].email+"-"+start_date].talent:"-")),
              oldTalent:OldtalentTeam[user]==allUserKey[user].talent?(""):(OldtalentTeam[user]?OldtalentTeam[user]=="Marginalized"?"Starter":(OldtalentTeam[user]=="Hidden Talent"?"Hidden Gem":OldtalentTeam[user]):""),
              excelsAt:result,
              excelsCount:result.length,
              outstanding:_engagement[allUserKey[user].email+"-"+start_date].truly?_engagement[allUserKey[user].email+"-"+start_date].truly:0,
              impact_rating:_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].impact_rating?(_engagement[allUserKey[user].email+"-"+start_date].impact_rating*1.0).toFixed(1):0,
              impact_rating_lastweek:_engagement[allUserKey[user].email+"-"+end_date]&&_engagement[allUserKey[user].email+"-"+end_date].impact_rating?(_engagement[allUserKey[user].email+"-"+end_date].impact_rating*1.0).toFixed(1):0,
              impact_rating_change:((_engagement[allUserKey[user].email+"-"+start_date]&&_engagement[allUserKey[user].email+"-"+start_date].impact_rating?(_engagement[allUserKey[user].email+"-"+start_date].impact_rating*1.0):0)-(_engagement[allUserKey[user].email+"-"+end_date]&&_engagement[allUserKey[user].email+"-"+end_date].impact_rating?(_engagement[allUserKey[user].email+"-"+end_date].impact_rating*1.0):0)).toFixed(1),            
              network_type:_engagement[allUserKey[user].email+"-"+start_date].network_type?_engagement[allUserKey[user].email+"-"+start_date].network_type:"-",
              engagedType: engagedType,
              medalCount:medalCount,
              truly:_engagement[allUserKey[user].email+"-"+start_date].truly, 
              star:_engagement[allUserKey[user].email+"-"+start_date].star
          })
        }



            }
          }
          if(value.boss){
        
            PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
            Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
            Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
            Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
            Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
            Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
            Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
            Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
            Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));

            PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
            PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
            performingData.push(PersonalGrowth)
            Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
            Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
            performingData.push(Recognition)
            Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
            Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
            performingData.push(Rel_Colleagues)
            Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
            Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
            performingData.push(Satisfaction)
            Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
            Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
            performingData.push(Ambassadorship)
            Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
            Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
            performingData.push(Feedback)
            Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
            Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
            performingData.push(Rel_Manager)
            Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
            Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
            performingData.push(Wellness)
            Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
            Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
            performingData.push(Company_Alignment)
            
            let _performingData =_.orderBy(performingData, ['calulate'], ['desc'])
            commit('setPerformingData', _performingData)
            

          }
          if(checkPeople){
                var networkbulding_color=""
                let engagementKey: Array<any> = []
                let engagedType: string = ''
                let engagedSort=0
                
                if(!_engagement[value.email+"-"+start_date].daily_answer){
                  engagedType = "inActive"
                  engagedSort=6
                  state.directReports.engagedValue.inActive++
                }
                else if (_engagement[value.email+"-"+start_date].daily_color === 'green' &&
                  _engagement[value.email+"-"+start_date].feedback_color === 'green' &&
                  _engagement[value.email+"-"+start_date].super_feedback_color !== 'red' &&
                  _engagement[value.email+"-"+start_date].recognition_color === 'green' &&
                  _engagement[value.email+"-"+start_date].super_recognition_color !== 'red' &&
                  _engagement[value.email+"-"+start_date].happily_village_color !== 'red' &&
                  _engagement[value.email+"-"+start_date].peerfeedback_color === 'green' ) {
                  engagedType = "highlyEngaged"
                  engagedSort=2
                  
                  state.directReports.engagedValue.highlyEngaged++
        
                } else if (_engagement[value.email+"-"+start_date].daily_color === 'green' &&
                  _engagement[value.email+"-"+start_date].feedback_color !== 'red' &&
                  _engagement[value.email+"-"+start_date].recognition_color !== 'red') {
                  engagedType = "moderatelyEngaged"
                  engagedSort=3
                  state.directReports.engagedValue.moderatelyEngaged++
        
                } else if (_engagement[value.email+"-"+start_date].daily_color !== 'red') {
                  engagedType = "somewhatEngaged"
                  engagedSort=4
                
                  state.directReports.engagedValue.somewhatEngaged++
        
                } else {
                  engagedType = "underEngaged"
                  engagedSort=5
                  
                  state.directReports.engagedValue.notEngaged++
        
                }
                
            var result:Array<any>=[]
            if(_engagement[value.email+"-"+start_date]){
            for (const excel in _engagement[value.email+"-"+start_date].excels) {
              let data={name:excel,value:_engagement[value.email+"-"+start_date].excels[excel]}
              result.push(data)
            }
          }
            if((state.userDetail.newInnerNetwork+state.userDetail.newOuterNetwork)>0){
              networkbulding_color="green"
            }
            else{
              networkbulding_color="red"
            }
            var redeem_rewards_color=""
            if(_engagement[value.email+"-"+start_date].redeem_rewards_count>=1)
            {
              redeem_rewards_color="green"
            }else {
              redeem_rewards_color="red"
            }
            if(_engagement[value.email+"-"+start_date]){
            engagement.challenges.dailyCheck=_engagement[value.email+"-"+start_date].daily_color
            engagement.challenges.peerFeedback=_engagement[value.email+"-"+start_date].peerfeedback_color
            engagement.challenges.feedback=_engagement[value.email+"-"+start_date].feedback_color
            engagement.challenges.happilyVillage=_engagement[value.email+"-"+start_date].happily_village_color
            engagement.challenges.superFeedback=_engagement[value.email+"-"+start_date].super_feedback_color
            engagement.challenges.rewards=redeem_rewards_color//_engagement[value.email+"-"+start_date].redeem_rewards_color
            engagement.challenges.recognition=_engagement[value.email+"-"+start_date].recognition_color
            engagement.challenges.favoritedSparks=_engagement[value.email+"-"+start_date].favorite_spark_color
            engagement.challenges.superRecognition=_engagement[value.email+"-"+start_date].super_recognition_color
            engagement.challenges.NetworkBuilding=networkbulding_color//_engagement[value.email+"-"+start_date].networkbulding_color
            let sortNot_good = _.sortBy(_engagement[value.email+"-"+start_date].report_card_notgood, [function (o: any) { return o.priority; }])
            let good=_engagement[value.email+"-"+start_date].report_card_good
            if(sortNot_good.length==0){
              engagementKey.push(good + " viewpoints that are positive & healthy")
            }else if(sortNot_good.length==1){
              engagementKey.push(sortNot_good[0].text, `${good} viewpoints that are positive & healthy`)
            }else{
              engagementKey.push(sortNot_good[0].text, sortNot_good[1].text, `${good} viewpoints that are positive & healthy`)
            }
            let setData = {
              name: value.firstname + " " +value.lastname,
              firstname: value.firstname,
              lastname:value.lastname,
              image: value.profilepic,
              teamName: value.teamName,
              engagedType: engagedType,
              engagementKey: engagementKey,
              sort:engagedSort
            }
            
            engagedData.push(setData)


            //====setContributions====//
            data_Contribution={
              dailyAttendance:_engagement[value.email+"-"+start_date].daily,
              dailyAttendanceStatus:_engagement[value.email+"-"+start_date].daily_color,
              feedbackShared:_engagement[value.email+"-"+start_date].feedback,
              feedbackSharedStatus: _engagement[value.email+"-"+start_date].feedback_color,
              managerReplyRate:_engagement[value.email+"-"+start_date].replyrate?_engagement[value.email+"-"+start_date].replyrate:'',
              managerReplyRateStatus:_engagement[value.email+"-"+start_date].replyrate_color?_engagement[value.email+"-"+start_date].replyrate_color:'',
              insightsOpened:_engagement[value.email+"-"+start_date].insight?((_engagement[value.email+"-"+start_date].insight*100)>100?100:_engagement[value.email+"-"+start_date].insight*100):"",
              insightsOpenedStatus:_engagement[value.email+"-"+start_date].insight_color?_engagement[value.email+"-"+start_date].insight_color:"",
              recognitionGiven:_engagement[value.email+"-"+start_date].recognition,
              recognitionGivenStatus:_engagement[value.email+"-"+start_date].recognition_color,
              peerFeedback: _engagement[value.email+"-"+start_date].peerfeedback,
              peerFeedbackStatus: _engagement[value.email+"-"+start_date].peerfeedback_color,
              
          }
          
          ///===you feeling====
          for(let j=0;j<lastDayOfMonth;j++){
            const day=(j+1)<10?"0"+(j+1):(j+1)
            const date=value.year+"-"+value.num_month+"-"+day
            let weekend = format(date, "dd");
            let skill=''
                let steps:any=''
                let sleep:any=''
                if(_engagement[value.email+"-"+start_date].power_skill&&_engagement[value.email+"-"+start_date].power_skill[date]){
                  for(const key in _engagement[value.email+"-"+start_date].power_skill[date]){
                    if(_engagement[value.email+"-"+start_date].power_skill[date][key].skip){
                      skill="skip"
                    }else if(_engagement[value.email+"-"+start_date].power_skill[date][key].answer){
                      skill=skillMaster[key]
                    }
                  }
                 
                }
                if(users_sleep_steps[date]){
                  steps=users_sleep_steps[date].steps?users_sleep_steps[date].steps>5000?'1':'0':''
                  sleep=users_sleep_steps[date].sleep?users_sleep_steps[date].sleep/60>=7?'1':'0':''
                }
            
            if(weekend!=="Su"&&weekend!=="Sa"){
            var _holiday = _.find(holiday, function(value){
                return value != null && value.date == date;
              });
                if(j==0){
                    let dayLabel = format(date, "d");
                    
                    for(let i=1;i<parseInt(dayLabel);i++){
                        youFeeling.push("no_ring.png")
                        //youFeeling.push("#DBDBDB")
                        
                    }
                    
                }
              if(_engagement[value.email+"-"+start_date].daily_answer&&!_holiday){

              
                if(_engagement[value.email+"-"+start_date].daily_answer[date]&&!_holiday){
                  if(_engagement[value.email+"-"+start_date].daily_answer[date]==="green"){
                        // youFeeling.push("#27BC6C")
                        const img =await dispatch('getRingImage',{reflection:'g',skill:skill,movement:steps,sleep:sleep})//this.getRingImage('g',skill,sleep,sleep)
                        youFeeling.push(img)
                        if(!value.boss){
                          status_feeling.good++
                        }
                  }else if(_engagement[value.email+"-"+start_date].daily_answer[date]==="yellow"){
                        // youFeeling.push("#FFBA0D")
                        const img =await dispatch('getRingImage',{reflection:'y',skill:skill,movement:steps,sleep:sleep})//this.getRingImage('y',skill,sleep,sleep)
                        youFeeling.push(img)
                        if(!value.boss){
                          status_feeling.okay++
                        }
                  }else if(_engagement[value.email+"-"+start_date].daily_answer[date]==="red"){
                        //youFeeling.push("#F22F3C")
                        const img =await dispatch('getRingImage',{reflection:'r',skill:skill,movement:steps,sleep:sleep})//this.getRingImage('r',skill,sleep,sleep)
                        youFeeling.push(img) 
                        if(!value.boss){
                          status_feeling.critical++
                        }
                    
                  }else{
                    const img =await dispatch('getRingImage',{reflection:'',skill:skill,movement:steps,sleep:sleep})//this.getRingImage('',skill,sleep,sleep)
                    youFeeling.push(img) 
                    //youFeeling.push("#7B7B7B")
                  }
                }else{
                    if(_holiday){
                        const img =await dispatch('getRingImage',{reflection:'h',skill:skill,movement:steps,sleep:sleep})//this.getRingImage('h',skill,sleep,sleep)
                        youFeeling.push(img) 
                        //youFeeling.push("#DBDBDB")
                        
                    }else{
                        const img =await dispatch('getRingImage',{reflection:'',skill:skill,movement:steps,sleep:sleep})//this.getRingImage('',skill,sleep,sleep)
                        youFeeling.push(img) 
                        //youFeeling.push("#7B7B7B")
                        
                    }
                }
              }else{
                if(_holiday){
                    const img =await dispatch('getRingImage',{reflection:'h',skill:skill,movement:steps,sleep:sleep})//this.getRingImage('h',skill,sleep,sleep)
                      youFeeling.push(img)
                  //youFeeling.push("#DBDBDB")
                  
              }else{
                const img =await dispatch('getRingImage',{reflection:'',skill:skill,movement:steps,sleep:sleep})//this.getRingImage('',skill,sleep,sleep)
                youFeeling.push(img) 
                  //youFeeling.push("#7B7B7B")
                  
              }

              }
            }
          
            if(j==lastDayOfMonth-1)
            {
                
                if(youFeeling.length<25){
                    for(let i=youFeeling.length;i<25;i++)
                    {
                        youFeeling.push("no_ring.png")
                        //youFeeling.push("#DBDBDB")
                    }
                    
                }

            }
            
          }
            
          if(!value.boss){
            
            commit('setFeeling', status_feeling)
          }

          if(value.boss){
            if(_engagement[value.email+"-"+start_date].insight_teams_manager){
              ///===team feeling====
              for(let j=0;j<lastDayOfMonth;j++){
                const day=(j+1)<10?"0"+(j+1):(j+1)
                const date=value.year+"-"+value.num_month+"-"+day
                let weekend = format(date, "dd");
              
                if(weekend!=="Su"&&weekend!=="Sa"){
                var _holiday = _.find(holiday, function(value){
                    return value != null && value.date == date;
                  });
                    if(j==0){
                        let dayLabel = format(date, "d");
                        
                        for(let i=1;i<parseInt(dayLabel);i++){
                          feeling.push("#C4C4C4")
                            
                        }
                        
                    }
                    if(_engagement[value.email+"-"+start_date].insight_teams_manager[date]&&!_holiday){
                      if(_engagement[value.email+"-"+start_date].insight_teams_manager[date]==="green"){
                        feeling.push("#27BC6C")
                            status_feeling.good++
                      }else if(_engagement[value.email+"-"+start_date].insight_teams_manager[date]==="yellow"){
                        feeling.push("#FFBA0D")
                            status_feeling.okay++
                      }else if(_engagement[value.email+"-"+start_date].insight_teams_manager[date]==="red"){
                        feeling.push("#F22F3C")
                        status_feeling.critical++
                      }else{
                        feeling.push("#7B7B7B")
                      }
                    }else{
                        if(_holiday){
                          feeling.push("#C4C4C4")
                            
                        }else{
                          feeling.push("#7B7B7B")
                            
                        }
                    }
                }
                if(j==lastDayOfMonth-1)
                {
                    
                    if(feeling.length<25){
                        for(let i=feeling.length;i<25;i++)
                        {
                          feeling.push("#C4C4C4")
                            
                        }
                        
                    }
    
                }
                
            }
          }else{
            for(let i=feeling.length;i<25;i++)
            {

              feeling.push("#7B7B7B")
            }

          }

                commit('setFeeling', status_feeling)
                commit('setTeamFeeling', feeling)
                
    
          }
        }

          if(!value.boss){

            PersonalGrowth={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Recognition={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Rel_Colleagues={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Satisfaction={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Ambassadorship={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Feedback={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Wellness={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Company_Alignment={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Rel_Manager={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}

          }
          if(_engagement[value.email+"-"+start_date]){
            if(_engagement[value.email+"-"+start_date].dimensions){
            PersonalGrowth.value=PersonalGrowth.value+(_engagement[value.email+"-"+start_date].dimensions.PersonalGrowth?_engagement[value.email+"-"+start_date].dimensions.PersonalGrowth.value:0)
            Recognition.value=Recognition.value+(_engagement[value.email+"-"+start_date].dimensions.Recognition?_engagement[value.email+"-"+start_date].dimensions.Recognition.value:0)
            Rel_Colleagues.value=Rel_Colleagues.value+(_engagement[value.email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[value.email+"-"+start_date].dimensions.Rel_Colleagues.value:0)
            Satisfaction.value=Satisfaction.value+(_engagement[value.email+"-"+start_date].dimensions.Satisfaction?_engagement[value.email+"-"+start_date].dimensions.Satisfaction.value:0)
            Ambassadorship.value=Ambassadorship.value+(_engagement[value.email+"-"+start_date].dimensions.Ambassadorship?_engagement[value.email+"-"+start_date].dimensions.Ambassadorship.value:0)
            Feedback.value=Feedback.value+(_engagement[value.email+"-"+start_date].dimensions.Feedback?_engagement[value.email+"-"+start_date].dimensions.Feedback.value:0)
            Rel_Manager.value=Rel_Manager.value+(_engagement[value.email+"-"+start_date].dimensions.Rel_Manager?_engagement[value.email+"-"+start_date].dimensions.Rel_Manager.value:0)
            Wellness.value=Wellness.value+(_engagement[value.email+"-"+start_date].dimensions.Wellness?_engagement[value.email+"-"+start_date].dimensions.Wellness.value:0)
            Company_Alignment.value=Company_Alignment.value+(_engagement[value.email+"-"+start_date].dimensions.Company_Alignment?_engagement[value.email+"-"+start_date].dimensions.Company_Alignment.value:0)


            PersonalGrowth.total=PersonalGrowth.total+(_engagement[value.email+"-"+start_date].dimensions.PersonalGrowth?_engagement[value.email+"-"+start_date].dimensions.PersonalGrowth.total:0)
            Recognition.total=Recognition.total+(_engagement[value.email+"-"+start_date].dimensions.Recognition?_engagement[value.email+"-"+start_date].dimensions.Recognition.total:0)
            Rel_Colleagues.total=Rel_Colleagues.total+(_engagement[value.email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[value.email+"-"+start_date].dimensions.Rel_Colleagues.total:0)
            Satisfaction.total=Satisfaction.total+(_engagement[value.email+"-"+start_date].dimensions.Satisfaction?_engagement[value.email+"-"+start_date].dimensions.Satisfaction.total:0)
            Ambassadorship.total=Ambassadorship.total+(_engagement[value.email+"-"+start_date].dimensions.Ambassadorship?_engagement[value.email+"-"+start_date].dimensions.Ambassadorship.total:0)
            Feedback.total=Feedback.total+(_engagement[value.email+"-"+start_date].dimensions.Feedback?_engagement[value.email+"-"+start_date].dimensions.Feedback.total:0)
            Rel_Manager.total=Rel_Manager.total+(_engagement[value.email+"-"+start_date].dimensions.Rel_Manager?_engagement[value.email+"-"+start_date].dimensions.Rel_Manager.total:0)
            Wellness.total=Wellness.total+(_engagement[value.email+"-"+start_date].dimensions.Wellness?_engagement[value.email+"-"+start_date].dimensions.Wellness.total:0)
            Company_Alignment.total=Company_Alignment.total+(_engagement[value.email+"-"+start_date].dimensions.Company_Alignment?_engagement[value.email+"-"+start_date].dimensions.Company_Alignment.total:0)
            }
          }

          if(_engagement[value.email+"-"+end_date]){
            if(_engagement[value.email+"-"+end_date].dimensions){
            // //====old=====
            PersonalGrowth.previous_value=PersonalGrowth.previous_value+(_engagement[value.email+"-"+end_date].dimensions.PersonalGrowth?_engagement[value.email+"-"+end_date].dimensions.PersonalGrowth.value:0)
            Recognition.previous_value=Recognition.previous_value+(_engagement[value.email+"-"+end_date].dimensions.Recognition?_engagement[value.email+"-"+end_date].dimensions.Recognition.value:0)
            Rel_Colleagues.previous_value=Rel_Colleagues.previous_value+(_engagement[value.email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[value.email+"-"+end_date].dimensions.Rel_Colleagues.value:0)
            Satisfaction.previous_value=Satisfaction.previous_value+(_engagement[value.email+"-"+end_date].dimensions.Satisfaction?_engagement[value.email+"-"+end_date].dimensions.Satisfaction.value:0)
            Ambassadorship.previous_value=Ambassadorship.previous_value+(_engagement[value.email+"-"+end_date].dimensions.Ambassadorship?_engagement[value.email+"-"+end_date].dimensions.Ambassadorship.value:0)
            Feedback.previous_value=Feedback.previous_value+(_engagement[value.email+"-"+end_date].dimensions.Feedback?_engagement[value.email+"-"+end_date].dimensions.Feedback.value:0)
            Rel_Manager.previous_value=Rel_Manager.previous_value+(_engagement[value.email+"-"+end_date].dimensions.Rel_Manager?_engagement[value.email+"-"+end_date].dimensions.Rel_Manager.value:0)
            Wellness.previous_value=Wellness.previous_value+(_engagement[value.email+"-"+end_date].dimensions.Wellness?_engagement[value.email+"-"+end_date].dimensions.Wellness.value:0)
            Company_Alignment.previous_value=Company_Alignment.previous_value+(_engagement[value.email+"-"+end_date].dimensions.Company_Alignment?_engagement[value.email+"-"+end_date].dimensions.Company_Alignment.value:0)


            PersonalGrowth.previous_total=PersonalGrowth.previous_total+(_engagement[value.email+"-"+end_date].dimensions.PersonalGrowth?_engagement[value.email+"-"+end_date].dimensions.PersonalGrowth.total:0)
            Recognition.previous_total=Recognition.previous_total+(_engagement[value.email+"-"+end_date].dimensions.Recognition?_engagement[value.email+"-"+end_date].dimensions.Recognition.total:0)
            Rel_Colleagues.previous_total=Rel_Colleagues.previous_total+(_engagement[value.email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[value.email+"-"+end_date].dimensions.Rel_Colleagues.total:0)
            Satisfaction.previous_total=Satisfaction.previous_total+(_engagement[value.email+"-"+end_date].dimensions.Satisfaction?_engagement[value.email+"-"+end_date].dimensions.Satisfaction.total:0)
            Ambassadorship.previous_total=Ambassadorship.previous_total+(_engagement[value.email+"-"+end_date].dimensions.Ambassadorship?_engagement[value.email+"-"+end_date].dimensions.Ambassadorship.total:0)
            Feedback.previous_total=Feedback.previous_total+(_engagement[value.email+"-"+end_date].dimensions.Feedback?_engagement[value.email+"-"+end_date].dimensions.Feedback.total:0)
            Rel_Manager.previous_total=Rel_Manager.previous_total+(_engagement[value.email+"-"+end_date].dimensions.Rel_Manager?_engagement[value.email+"-"+end_date].dimensions.Rel_Manager.total:0)
            Wellness.previous_total=Wellness.previous_total+(_engagement[value.email+"-"+end_date].dimensions.Wellness?_engagement[value.email+"-"+end_date].dimensions.Wellness.total:0)
            Company_Alignment.previous_total=Company_Alignment.previous_total+(_engagement[value.email+"-"+end_date].dimensions.Company_Alignment?_engagement[value.email+"-"+end_date].dimensions.Company_Alignment.total:0)
            }
          }
          if(!value.boss){
            PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
            Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
            Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
            Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
            Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
            Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
            Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
            Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
            Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));

            PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
            PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
            performingData.push(PersonalGrowth)
            Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
            Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
            performingData.push(Recognition)
            Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
            Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
            performingData.push(Rel_Colleagues)
            Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
            Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
            performingData.push(Satisfaction)
            Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
            Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
            performingData.push(Ambassadorship)
            Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
            Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
            performingData.push(Feedback)
            Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
            Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
            performingData.push(Rel_Manager)
            Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
            Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
            performingData.push(Wellness)
            Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
            Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
            performingData.push(Company_Alignment)
              let _performingData =_.orderBy(performingData, ['calulate'], ['desc'])
              commit('setPerformingData', _performingData)
          
          }
          
          userCardData={
            name: (value.firstname+" "+value.lastname.slice(0, 1)),
            firstname: value.firstname,
            lastname: value.lastname,
            image:value.profilepic,
            talentChanged:OldtalentTeam[value.email]?(value.talent===OldtalentTeam[value.email]?true:false):false, 
            email:value.email,
            starPerformer:value.star,
            talent:value.talent=="Marginalized"?"Starter":(value.talent=="Hidden Talent"?"Hidden Gem":value.talent),
            oldTalent:OldtalentTeam[value.email]?OldtalentTeam[value.email]=="Marginalized"?"Starter":(OldtalentTeam[value.email]=="Hidden Talent"?"Hidden Gem":OldtalentTeam[value.email]):"",
            excelsAt:result,
            outstanding:_engagement[value.email+"-"+start_date].truly?_engagement[value.email+"-"+start_date].truly:0
        }
            commit('setuserCardData', userCardData)
            commit('setYouFeeling', youFeeling)
            commit('setContributions', data_Contribution)
            commit("setEngagement",{...engagement,engagementKey:engagementKey,engagementType:engagedType})




          }
          commit("setLoadingProgress",state.loadingProgress+25)
          directReports.map(data=>{
            const emailKey = value.email.replace(/\./g, '||')
            data.value=talentTeam[data.name]?talentTeam[data.name]:0
            data.highlight=value.talent===data.name?true:false
            data.oldhighlight=OldtalentTeam[emailKey]===data.name?true:false
            data.name=data.name=="Marginalized"?"Starter":(data.name=="Hidden Talent"?"Hidden Gem":data.name)
        })

        //console.log("growingTeam",growingTeam)
        console.log('directReports',directReports)
          commit('setGrowingData', {directReports:directReports})
          commit("setDirectReportsEngagedData",  _.sortBy(engagedData, [function (o: any) { return o.sort; }]))
          commit('setPartTalentTeam',_.orderBy(growingTeam, ['impact_rating', 'name'], ['desc','asc']))
          commit("setDirectReportsLoading", false)
          commit('setloading', false)
          commit("setloadingStatus",false)
          setTimeout(() => { 
            commit("setLoadingProgress",state.loadingProgress+26)
          }, 1000)
          
        })
      
    },
    getRingImage({ commit, dispatch, rootState, state ,getters}: any,data:any) {
            let imageName = ''
            const reflection=data.reflection
            const skill=data.skill
            const movement=data.movement
            const sleep=data.sleep
        
            if(reflection !== ''){
                if(skill === ''){
                    if(reflection === 'h'){
                        if(movement === '' && sleep === '') {
                            imageName = "ring_0_0_null_null.png"//require('../images/spark/ring/ring_0_0_null_null.png');
                        }else if(movement === '0' && sleep === '0') {
                            imageName ="ring_0_0_0_0.png"// require('../images/spark/ring/ring_0_0_0_0.png');
                        }else if (movement === '1' && sleep === '1') {
                            imageName = "ring_0_0_1_1.png"//require('../images/spark/ring/ring_0_0_1_1.png'); 
                        }else if (movement === '0' && sleep === '1') {
                            imageName = "ring_0_0_0_1.png"//require('../images/spark/ring/ring_0_0_0_1.png'); 
                        }else if (movement === '1' && sleep === '0') {
                            imageName = "ring_0_0_1_0.png"//require('../images/spark/ring/ring_0_0_1_0.png');
                        }else if(movement === '' && sleep === '0') { 
                            imageName = "ring_0_0_null_0.png"//require('../images/spark/ring/ring_0_0_null_0.png');
                        }else if(movement === '' && sleep === '1') {
                            imageName = "ring_0_0_null_1.png"//require('../images/spark/ring/ring_0_0_null_1.png');
                        }else if(movement === 0 && sleep === '') {
                            imageName = "ring_0_0_0_null.png"//require('../images/spark/ring/ring_0_0_0_null.png');
                        }else if(movement === '1' && sleep === '') {
                            imageName = "ring_0_0_1_null.png"//require('../images/spark/ring/ring_0_0_1_null.png');
                        }else{
                            imageName ="no_ring.png" //require('../images/spark/ring/no_ring.png');
                        }
                    }else{
                        if(movement === '' && sleep === '') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_null_null.png"//require('../images/spark/ring/ring_r_0_null_null.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_null_null.png"//require('../images/spark/ring/ring_g_0_null_null.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_null_null.png"//require('../images/spark/ring/ring_y_0_null_null.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '0' && sleep === '0') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_0_0.png"//require('../images/spark/ring/ring_r_0_0_0.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_0_0.png"//require('../images/spark/ring/ring_g_0_0_0.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_0_0.png"//require('../images/spark/ring/ring_y_0_0_0.png');
                            }else{
                                imageName = "no_ring.png"// require('../images/spark/ring/no_ring.png');
                            }
                        } else if (movement === '1' && sleep === '1') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_1_1.png"//require('../images/spark/ring/ring_r_0_1_1.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_1_1.png"//require('../images/spark/ring/ring_g_0_1_1.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_1_1.png"//require('../images/spark/ring/ring_y_0_1_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if (movement === '0' && sleep === '1') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_0_1.png"//require('../images/spark/ring/ring_r_0_0_1.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_0_1.png"//require('../images/spark/ring/ring_g_0_0_1.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_0_1.png"//require('../images/spark/ring/ring_y_0_0_1.png');
                            }else{
                                imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if (movement === '1' && sleep === '0') {
                            if(reflection === 'r'){   
                                imageName =  "ring_r_0_1_0.png"//require('../images/spark/ring/ring_r_0_1_0.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_1_0.png"//require('../images/spark/ring/ring_g_0_1_0.png');
                            }else if(reflection === 'y'){
                                imageName =  "ring_y_0_1_0.png"//require('../images/spark/ring/ring_y_0_1_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '' && sleep === '0') { 
                            if(reflection === 'r'){   
                                imageName =  "ring_r_0_null_0.png"//require('../images/spark/ring/ring_r_0_null_0.png');
                            }else if(reflection === 'g'){
                                imageName =  "ring_g_0_null_0.png"//require('../images/spark/ring/ring_g_0_null_0.png'); 
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_null_0.png"//require('../images/spark/ring/ring_y_0_null_0.png'); 
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '' && sleep === '1') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_null_1.png"//require('../images/spark/ring/ring_r_0_null_1.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_null_1.png"//require('../images/spark/ring/ring_g_0_null_1.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_null_1.png"//require('../images/spark/ring/ring_y_0_null_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '0' && sleep === '') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_0_null.png"//require('../images/spark/ring/ring_r_0_0_null.png'); 
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_0_null.png"//require('../images/spark/ring/ring_g_0_0_null.png'); 
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_0_null.png"//require('../images/spark/ring/ring_y_0_0_null.png'); 
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }
                        }else if(movement === '1' && sleep === '') {
                            if(reflection === 'r'){   
                                imageName = "ring_r_0_1_null.png"//require('../images/spark/ring/ring_r_0_1_null.png');
                            }else if(reflection === 'g'){
                                imageName = "ring_g_0_1_null.png"//require('../images/spark/ring/ring_g_0_1_null.png');
                            }else if(reflection === 'y'){
                                imageName = "ring_y_0_1_null.png"//require('../images/spark/ring/ring_y_0_1_null.png');
                            }else{
                                imageName =  "no_ring.png" //require('../images/spark/ring/no_ring.png');
                            }
                        }else{
                            imageName =  "no_ring.png" //require('../images/spark/ring/no_ring.png');
                        }
                    }
                }else if(skill !== '' && movement === '' && sleep === '') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName = "ring_r_e_null_null.png"//require('../images/spark/ring/ring_r_e_null_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_r_s_null_null.png"//require('../images/spark/ring/ring_r_s_null_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_r_c_null_null.png"//require('../images/spark/ring/ring_r_c_null_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_r_l_null_null.png"//require('../images/spark/ring/ring_r_l_null_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_r_i_null_null.png"//require('../images/spark/ring/ring_r_i_null_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_r_o_null_null.png"//require('../images/spark/ring/ring_r_o_null_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_r_skip_null_null.png"//require('../images/spark/ring/ring_r_skip_null_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_null_null.png"//require('../images/spark/ring/ring_g_e_null_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_g_s_null_null.png"//require('../images/spark/ring/ring_g_s_null_null.png');
                        }else if(skill === 'c'){
                            imageName =  "ring_g_c_null_null.png"//require('../images/spark/ring/ring_g_c_null_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_g_l_null_null.png"//require('../images/spark/ring/ring_g_l_null_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_g_i_null_null.png"//require('../images/spark/ring/ring_g_i_null_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_g_o_null_null.png"//require('../images/spark/ring/ring_g_o_null_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_null_null.png"//require('../images/spark/ring/ring_g_skip_null_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName = "ring_y_e_null_null.png"//require('../images/spark/ring/ring_y_e_null_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_y_s_null_null.png"//require('../images/spark/ring/ring_y_s_null_null.png');
                        }else if(skill === 'c'){
                            imageName =  "ring_y_c_null_null.png"//require('../images/spark/ring/ring_y_c_null_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_y_l_null_null.png"//require('../images/spark/ring/ring_y_l_null_null.png');
                        }else if(skill === 'i'){
                            imageName =  "ring_y_i_null_null.png"//require('../images/spark/ring/ring_y_i_null_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_y_o_null_null.png"//require('../images/spark/ring/ring_y_o_null_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_y_skip_null_null.png"//require('../images/spark/ring/ring_y_skip_null_null.png');
                        }else{
                            imageName ="no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement !== '' && sleep !== '') {
                    if(movement === '0' && sleep === '0') {
                        if(reflection === 'r'){   
                            if(skill === 'e'){
                                imageName = "ring_r_e_0_0.png"//require('../images/spark/ring/ring_r_e_0_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_r_s_0_0.png"//require('../images/spark/ring/ring_r_s_0_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_r_c_0_0.png"//require('../images/spark/ring/ring_r_c_0_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_r_l_0_0.png"//require('../images/spark/ring/ring_r_l_0_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_r_i_0_0.png"//require('../images/spark/ring/ring_r_i_0_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_r_o_0_0.png"//require('../images/spark/ring/ring_r_o_0_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_r_skip_0_0.png"//require('../images/spark/ring/ring_r_skip_0_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }    
                        }else if(reflection === 'g'){
                            if(skill === 'e'){
                                imageName = "ring_g_e_0_0.png"//require('../images/spark/ring/ring_g_e_0_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_g_s_0_0.png"//require('../images/spark/ring/ring_g_s_0_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_g_c_0_0.png"//require('../images/spark/ring/ring_g_c_0_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_g_l_0_0.png"//require('../images/spark/ring/ring_g_l_0_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_g_i_0_0.png"//require('../images/spark/ring/ring_g_i_0_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_g_o_0_0.png"//require('../images/spark/ring/ring_g_o_0_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_g_skip_0_0.png"//require('../images/spark/ring/ring_g_skip_0_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else if(reflection === 'y'){
                            if(skill === 'e'){
                                imageName = "ring_y_e_0_0.png"//require('../images/spark/ring/ring_y_e_0_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_y_s_0_0.png"//require('../images/spark/ring/ring_y_s_0_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_y_c_0_0.png"//require('../images/spark/ring/ring_y_c_0_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_y_l_0_0.png"//require('../images/spark/ring/ring_y_l_0_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_y_i_0_0.png"//require('../images/spark/ring/ring_y_i_0_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_y_o_0_0.png"//require('../images/spark/ring/ring_y_o_0_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_y_skip_0_0.png"//require('../images/spark/ring/ring_y_skip_0_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }
                    }else if (movement === '1' && sleep === '1') {
                        if(reflection === 'r'){   
                            if(skill === 'e'){
                                imageName ="ring_r_e_1_1.png"// require('../images/spark/ring/ring_r_e_1_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_r_s_1_1.png"//require('../images/spark/ring/ring_r_s_1_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_r_c_1_1.png"//require('../images/spark/ring/ring_r_c_1_1.png');
                            }else if(skill === 'l'){
                                imageName = "ring_r_l_1_1.png"//require('../images/spark/ring/ring_r_l_1_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_r_i_1_1.png"//require('../images/spark/ring/ring_r_i_1_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_r_o_1_1.png"//require('../images/spark/ring/ring_r_o_1_1.png');
                            }else if(skill === 'skip'){
                                imageName =  "ring_r_skip_1_1.png"//require('../images/spark/ring/ring_r_skip_1_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }    
                        }else if(reflection === 'g'){
                            if(skill === 'e'){
                                imageName = "ring_g_e_1_1.png"//require('../images/spark/ring/ring_g_e_1_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_g_s_1_1.png"//require('../images/spark/ring/ring_g_s_1_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_g_c_1_1.png"//require('../images/spark/ring/ring_g_c_1_1.png');
                            }else if(skill === 'l'){
                                imageName = "ring_g_l_1_1.png"//require('../images/spark/ring/ring_g_l_1_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_g_i_1_1.png"//require('../images/spark/ring/ring_g_i_1_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_g_o_1_1.png"//require('../images/spark/ring/ring_g_o_1_1.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_g_skip_1_1.png"//require('../images/spark/ring/ring_g_skip_1_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else if(reflection === 'y'){
                            if(skill === 'e'){
                                imageName = "ring_y_e_1_1.png"//require('../images/spark/ring/ring_y_e_1_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_y_s_1_1.png"//require('../images/spark/ring/ring_y_s_1_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_y_c_1_1.png"//require('../images/spark/ring/ring_y_c_1_1.png');
                            }else if(skill === 'l'){
                                imageName =  "ring_y_l_1_1.png"//require('../images/spark/ring/ring_y_l_1_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_y_i_1_1.png"//require('../images/spark/ring/ring_y_i_1_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_y_o_1_1.png"//require('../images/spark/ring/ring_y_o_1_1.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_y_skip_1_1.png"//require('../images/spark/ring/ring_y_skip_1_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }
                    }else if (movement === '0' && sleep === '1') {
                        if(reflection === 'r'){   
                            if(skill === 'e'){
                                imageName = "ring_r_e_0_1.png"//require('../images/spark/ring/ring_r_e_0_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_r_s_0_1.png"//require('../images/spark/ring/ring_r_s_0_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_r_c_0_1.png"//require('../images/spark/ring/ring_r_c_0_1.png');
                            }else if(skill === 'l'){
                                imageName = "ring_r_l_0_1.png"//require('../images/spark/ring/ring_r_l_0_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_r_i_0_1.png"//require('../images/spark/ring/ring_r_i_0_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_r_o_0_1.png"//require('../images/spark/ring/ring_r_o_0_1.png');
                            }else if(skill === 'skip'){
                                
                                imageName = "ring_r_skip_0_1.png"//require('../images/spark/ring/ring_r_skip_0_1.png');
                            }else{
                                imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }    
                        }else if(reflection === 'g'){
                            if(skill === 'e'){
                                imageName = "ring_g_e_0_1.png"//require('../images/spark/ring/ring_g_e_0_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_g_s_0_1.png"//require('../images/spark/ring/ring_g_s_0_1.png');
                            }else if(skill === 'c'){
                                imageName ="ring_g_c_0_1.png"// require('../images/spark/ring/ring_g_c_0_1.png');
                            }else if(skill === 'l'){
                                imageName ="ring_g_l_0_1.png"// require('../images/spark/ring/ring_g_l_0_1.png');
                            }else if(skill === 'i'){
                                imageName = "ring_g_i_0_1.png"//require('../images/spark/ring/ring_g_i_0_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_g_o_0_1.png"//require('../images/spark/ring/ring_g_o_0_1.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_g_skip_0_1.png"//require('../images/spark/ring/ring_g_skip_0_1.png');
                            }else{
                                imageName = "no_ring.png"// require('../images/spark/ring/no_ring.png');
                            }  
                        }else if(reflection === 'y'){
                            if(skill === 'e'){
                                imageName = "ring_y_e_0_1.png"//require('../images/spark/ring/ring_y_e_0_1.png');
                            }else if(skill === 's'){
                                imageName = "ring_y_s_0_1.png"//require('../images/spark/ring/ring_y_s_0_1.png');
                            }else if(skill === 'c'){
                                imageName = "ring_y_c_0_1.png"//require('../images/spark/ring/ring_y_c_0_1.png');
                            }else if(skill === 'l'){
                                imageName = "ring_y_l_0_1.png"//require('../images/spark/ring/ring_y_l_0_1.png');
                            }else if(skill === 'i'){
                                imageName =  "ring_y_i_0_1.png"//require('../images/spark/ring/ring_y_i_0_1.png');
                            }else if(skill === 'o'){
                                imageName = "ring_y_o_0_1.png"//require('../images/spark/ring/ring_y_o_0_1.png');
                            }else if(skill === 'skip'){
                           
                                imageName = "ring_y_skip_0_1.png"//require('../images/spark/ring/ring_y_skip_0_1.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }
                    }else if (movement === '1' && sleep === '0') {
                        if(reflection === 'r'){   
                            if(skill === 'e'){
                                imageName = "ring_r_e_1_0.png"//require('../images/spark/ring/ring_r_e_1_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_r_s_1_0.png"//require('../images/spark/ring/ring_r_s_1_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_r_c_1_0.png"//require('../images/spark/ring/ring_r_c_1_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_r_l_1_0.png"//require('../images/spark/ring/ring_r_l_1_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_r_i_1_0.png"//require('../images/spark/ring/ring_r_i_1_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_r_o_1_0.png"//require('../images/spark/ring/ring_r_o_1_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_r_skip_1_0.png"//require('../images/spark/ring/ring_r_skip_1_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }    
                        }else if(reflection === 'g'){
                            if(skill === 'e'){
                                imageName =  "ring_g_e_1_0.png"//require('../images/spark/ring/ring_g_e_1_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_g_s_1_0.png"//require('../images/spark/ring/ring_g_s_1_0.png');
                            }else if(skill === 'c'){
                                imageName = "ring_g_c_1_0.png"//require('../images/spark/ring/ring_g_c_1_0.png');
                            }else if(skill === 'l'){
                                imageName = "ring_g_l_1_0.png"//require('../images/spark/ring/ring_g_l_1_0.png');
                            }else if(skill === 'i'){
                                imageName = "ring_g_i_1_0.png"//require('../images/spark/ring/ring_g_i_1_0.png');
                            }else if(skill === 'o'){
                                imageName =  "ring_g_o_1_0.png"//require('../images/spark/ring/ring_g_o_1_0.png');
                            }else if(skill === 'skip'){
                                imageName =  "ring_g_skip_1_0.png"//require('../images/spark/ring/ring_g_skip_1_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else if(reflection === 'y'){
                            if(skill === 'e'){
                                imageName = "ring_y_e_1_0.png"//require('../images/spark/ring/ring_y_e_1_0.png');
                            }else if(skill === 's'){
                                imageName = "ring_y_s_1_0.png"//require('../images/spark/ring/ring_y_s_1_0.png');
                            }else if(skill === 'c'){
                                imageName =  "ring_y_c_1_0.png"//require('../images/spark/ring/ring_y_c_1_0.png');
                            }else if(skill === 'l'){
                                imageName ="ring_y_l_1_0.png"// require('../images/spark/ring/ring_y_l_1_0.png');
                            }else if(skill === 'i'){
                                imageName ="ring_y_i_1_0.png"//require('../images/spark/ring/ring_y_i_1_0.png');
                            }else if(skill === 'o'){
                                imageName = "ring_y_o_1_0.png"//require('../images/spark/ring/ring_y_o_1_0.png');
                            }else if(skill === 'skip'){
                                imageName = "ring_y_skip_1_0.png"//require('../images/spark/ring/ring_y_skip_1_0.png');
                            }else{
                                imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                            }  
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement === '' && sleep === '0') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName =  "ring_r_e_null_0.png"//require('../images/spark/ring/ring_r_e_null_0.png');
                        }else if(skill === 's'){
                            imageName = "ring_r_s_null_0.png"//require('../images/spark/ring/ring_r_s_null_0.png');
                        }else if(skill === 'c'){
                            imageName = "ring_r_c_null_0.png"//require('../images/spark/ring/ring_r_c_null_0.png');
                        }else if(skill === 'l'){
                            imageName = "ring_r_l_null_0.png"//require('../images/spark/ring/ring_r_l_null_0.png');
                        }else if(skill === 'i'){
                            imageName = "ring_r_i_null_0.png"//require('../images/spark/ring/ring_r_i_null_0.png');
                        }else if(skill === 'o'){
                            imageName = "ring_r_o_null_0.png"//require('../images/spark/ring/ring_r_o_null_0.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_r_skip_null_0.png"//require('../images/spark/ring/ring_r_skip_null_0.png');
                        }else{
                            imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_null_0.png"//require('../images/spark/ring/ring_g_e_null_0.png');
                        }else if(skill === 's'){
                            imageName = "ring_g_s_null_0.png"//require('../images/spark/ring/ring_g_s_null_0.png');
                        }else if(skill === 'c'){
                            imageName = "ring_g_c_null_0.png"//require('../images/spark/ring/ring_g_c_null_0.png');
                        }else if(skill === 'l'){
                            imageName = "ring_g_l_null_0.png"//require('../images/spark/ring/ring_g_l_null_0.png');
                        }else if(skill === 'i'){
                            imageName = "ring_g_i_null_0.png"//require('../images/spark/ring/ring_g_i_null_0.png');
                        }else if(skill === 'o'){
                            imageName = "ring_g_o_null_0.png"//require('../images/spark/ring/ring_g_o_null_0.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_null_0.png"//require('../images/spark/ring/ring_g_skip_null_0.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName ="ring_y_e_null_0.png"// require('../images/spark/ring/ring_y_e_null_0.png');
                        }else if(skill === 's'){
                            imageName ="ring_y_s_null_0.png"// require('../images/spark/ring/ring_y_s_null_0.png');
                        }else if(skill === 'c'){
                            imageName = "ring_y_c_null_0.png"//require('../images/spark/ring/ring_y_c_null_0.png');
                        }else if(skill === 'l'){
                            imageName ="ring_y_l_null_0.png"// require('../images/spark/ring/ring_y_l_null_0.png');
                        }else if(skill === 'i'){
                            imageName = "ring_y_i_null_0.png"//require('../images/spark/ring/ring_y_i_null_0.png');
                        }else if(skill === 'o'){
                            imageName ="ring_y_o_null_0.png"// require('../images/spark/ring/ring_y_o_null_0.png');
                        }else if(skill === 'skip'){
                            imageName ="ring_y_skip_null_0.png"// require('../images/spark/ring/ring_y_skip_null_0.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement === '' && sleep === '1') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName = "ring_r_e_null_1.png"// require('../images/spark/ring/ring_r_e_null_1.png');
                        }else if(skill === 's'){
                            imageName = "ring_r_s_null_1.png"// require('../images/spark/ring/ring_r_s_null_1.png');
                        }else if(skill === 'c'){
                            imageName =  "ring_r_c_null_1.png"//require('../images/spark/ring/ring_r_c_null_1.png');
                        }else if(skill === 'l'){
                            imageName =  "ring_r_l_null_1.png"//require('../images/spark/ring/ring_r_l_null_1.png');
                        }else if(skill === 'i'){
                            imageName =  "ring_r_i_null_1.png"//require('../images/spark/ring/ring_r_i_null_1.png');
                        }else if(skill === 'o'){
                            imageName =  "ring_r_o_null_1.png"//require('../images/spark/ring/ring_r_o_null_1.png');
                        }else if(skill === 'skip'){
                            imageName =  "ring_r_skip_null_1.png"//require('../images/spark/ring/ring_r_skip_null_1.png');
                        }else{
                            imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_null_1.png"//require('../images/spark/ring/ring_g_e_null_1.png');
                        }else if(skill === 's'){
                            imageName ="ring_g_s_null_1.png"// require('../images/spark/ring/ring_g_s_null_1.png');
                        }else if(skill === 'c'){
                            imageName = "ring_g_c_null_1.png"//require('../images/spark/ring/ring_g_c_null_1.png');
                        }else if(skill === 'l'){
                            imageName = "ring_g_l_null_1.png"//require('../images/spark/ring/ring_g_l_null_1.png');
                        }else if(skill === 'i'){
                            imageName = "ring_g_i_null_1.png"//require('../images/spark/ring/ring_g_i_null_1.png');
                        }else if(skill === 'o'){
                            imageName = "ring_g_o_null_1.png"//require('../images/spark/ring/ring_g_o_null_1.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_null_1.png"//require('../images/spark/ring/ring_g_skip_null_1.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName = "ring_y_e_null_1.png"//require('../images/spark/ring/ring_y_e_null_1.png');
                        }else if(skill === 's'){
                            imageName = "ring_y_s_null_1.png"//require('../images/spark/ring/ring_y_s_null_1.png');
                        }else if(skill === 'c'){
                            imageName = "ring_y_c_null_1.png"//require('../images/spark/ring/ring_y_c_null_1.png');
                        }else if(skill === 'l'){
                            imageName = "ring_y_l_null_1.png"//require('../images/spark/ring/ring_y_l_null_1.png');
                        }else if(skill === 'i'){
                            imageName = "ring_y_i_null_1.png"//require('../images/spark/ring/ring_y_i_null_1.png');
                        }else if(skill === 'o'){
                            imageName = "ring_y_o_null_1.png"//require('../images/spark/ring/ring_y_o_null_1.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_y_skip_null_1.png"//require('../images/spark/ring/ring_y_skip_null_1.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement === '0' && sleep === '') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName = "ring_r_e_0_null.png"//require('../images/spark/ring/ring_r_e_0_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_r_s_0_null.png"//require('../images/spark/ring/ring_r_s_0_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_r_c_0_null.png"//require('../images/spark/ring/ring_r_c_0_null.png');
                        }else if(skill === 'l'){
                            imageName ="ring_r_l_0_null.png"// require('../images/spark/ring/ring_r_l_0_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_r_i_0_null.png"//require('../images/spark/ring/ring_r_i_0_null.png');
                        }else if(skill === 'o'){
                            imageName ="ring_r_o_0_null.png"// require('../images/spark/ring/ring_r_o_0_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_r_skip_0_null.png"//require('../images/spark/ring/ring_r_skip_0_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_0_null.png"//require('../images/spark/ring/ring_g_e_0_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_g_s_0_null.png"//require('../images/spark/ring/ring_g_s_0_null.png');
                        }else if(skill === 'c'){
                            imageName ="ring_g_c_0_null.png"// require('../images/spark/ring/ring_g_c_0_null.png');
                        }else if(skill === 'l'){
                            imageName ="ring_g_l_0_null.png"// require('../images/spark/ring/ring_g_l_0_null.png');
                        }else if(skill === 'i'){
                            imageName ="ring_g_i_0_null.png"// require('../images/spark/ring/ring_g_i_0_null.png');
                        }else if(skill === 'o'){
                            imageName ="ring_g_o_0_null.png"// require('../images/spark/ring/ring_g_o_0_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_0_null.png"//require('../images/spark/ring/ring_g_skip_0_null.png');
                        }else{
                            imageName ="no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName ="ring_y_e_0_null.png"//require('../images/spark/ring/ring_y_e_0_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_y_s_0_null.png"//require('../images/spark/ring/ring_y_s_0_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_y_c_0_null.png"//require('../images/spark/ring/ring_y_c_0_null.png');
                        }else if(skill === 'l'){
                            imageName ="ring_y_l_0_null.png"// require('../images/spark/ring/ring_y_l_0_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_y_i_0_null.png"//require('../images/spark/ring/ring_y_i_0_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_y_o_0_null.png"//require('../images/spark/ring/ring_y_o_0_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_y_skip_0_null.png"//require('../images/spark/ring/ring_y_skip_0_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }else if(skill !== '' && movement === '1' && sleep === '') {
                    if(reflection === 'r'){   
                        if(skill === 'e'){
                            imageName = "ring_r_e_1_null.png"//require('../images/spark/ring/ring_r_e_1_null.png');
                        }else if(skill === 's'){
                            imageName ="ring_r_s_1_null.png"// require('../images/spark/ring/ring_r_s_1_null.png');
                        }else if(skill === 'c'){
                            imageName ="ring_r_c_1_null.png"// require('../images/spark/ring/ring_r_c_1_null.png');
                        }else if(skill === 'l'){
                            imageName ="ring_r_l_1_null.png"// require('../images/spark/ring/ring_r_l_1_null.png');
                        }else if(skill === 'i'){
                            imageName ="ring_r_i_1_null.png"// require('../images/spark/ring/ring_r_i_1_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_r_o_1_null.png"//require('../images/spark/ring/ring_r_o_1_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_r_skip_1_null.png"//require('../images/spark/ring/ring_r_skip_1_null.png');
                        }else{
                            imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                        }    
                    }else if(reflection === 'g'){
                        if(skill === 'e'){
                            imageName = "ring_g_e_1_null.png"//require('../images/spark/ring/ring_g_e_1_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_g_s_1_null.png"//require('../images/spark/ring/ring_g_s_1_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_g_c_1_null.png"//require('../images/spark/ring/ring_g_c_1_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_g_l_1_null.png"//require('../images/spark/ring/ring_g_l_1_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_g_i_1_null.png"//require('../images/spark/ring/ring_g_i_1_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_g_o_1_null.png"//require('../images/spark/ring/ring_g_o_1_null.png');
                        }else if(skill === 'skip'){
                            imageName = "ring_g_skip_1_null.png"//require('../images/spark/ring/ring_g_skip_1_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else if(reflection === 'y'){
                        if(skill === 'e'){
                            imageName = "ring_y_e_1_null.png"//require('../images/spark/ring/ring_y_e_1_null.png');
                        }else if(skill === 's'){
                            imageName = "ring_y_s_1_null.png"//require('../images/spark/ring/ring_y_s_1_null.png');
                        }else if(skill === 'c'){
                            imageName = "ring_y_c_1_null.png"//require('../images/spark/ring/ring_y_c_1_null.png');
                        }else if(skill === 'l'){
                            imageName = "ring_y_l_1_null.png"//require('../images/spark/ring/ring_y_l_1_null.png');
                        }else if(skill === 'i'){
                            imageName = "ring_y_i_1_null.png"//require('../images/spark/ring/ring_y_i_1_null.png');
                        }else if(skill === 'o'){
                            imageName = "ring_y_o_1_null.png"//require('../images/spark/ring/ring_y_o_1_null.png');
                        }else if(skill === 'skip'){
                            imageName ="ring_y_skip_1_null.png"// require('../images/spark/ring/ring_y_skip_1_null.png');
                        }else{
                            imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                        }  
                    }else{
                        imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }
            }else{
                if(movement === '' && sleep === '') {
                    if(skill === "") {
                        imageName = "ring_skip_0_null_null.png"// require('../images/spark/ring/ring_skip_0_null_null.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_null_null.png"// require('../images/spark/ring/ring_skip_skip_null_null.png');
                    }else{
                        imageName = "no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }else if(movement === '0' && sleep === '0') {
                    if(skill === "") {
                        imageName = "ring_skip_0_0_0.png"//require('../images/spark/ring/ring_skip_0_0_0.png');
                    }else if(skill === "skip") {
                        imageName =  "ring_skip_skip_0_0.png"//require('../images/spark/ring/ring_skip_skip_0_0.png');
                    }else{
                        imageName = "no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }else if (movement === '1' && sleep === '1') {
                    if(skill === "") {
                        imageName = "ring_skip_0_1_1.png"//require('../images/spark/ring/ring_skip_0_1_1.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_1_1.png"//require('../images/spark/ring/ring_skip_skip_1_1.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    } 
                }else if (movement === '0' && sleep === '1') {
                    if(skill === "") {
                        imageName = "ring_skip_0_0_1.png"//require('../images/spark/ring/ring_skip_0_0_1.png');
                    }else if(skill === "skip") {
                        imageName ="ring_skip_skip_0_1.png"// require('../images/spark/ring/ring_skip_skip_0_1.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    } 
                }else if (movement === '1' && sleep === '0') {
                    if(skill === "") {
                        imageName = "ring_skip_0_1_0.png"//require('../images/spark/ring/ring_skip_0_1_0.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_1_0.png"//require('../images/spark/ring/ring_skip_skip_1_0.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    } 
                }else if(movement === '' && sleep === '0') { 
                    if(skill === "") {
                        imageName = "ring_skip_0_null_0.png"//require('../images/spark/ring/ring_skip_0_null_0.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_null_0.png"//require('../images/spark/ring/ring_skip_skip_null_0.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }     
                }else if(movement === '' && sleep ==='1') {
                    if(skill === "") {
                        imageName = "ring_skip_0_null_1.png"//require('../images/spark/ring/ring_skip_0_null_1.png');
                    }else if(skill === "skip") {
                        imageName = "ring_skip_skip_null_1.png"//require('../images/spark/ring/ring_skip_skip_null_1.png');
                    }else{
                        imageName = "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(movement === '0' && sleep === '') {
                    if(skill === "") {
                        imageName =  "ring_skip_0_0_null.png"//require('../images/spark/ring/ring_skip_0_0_null.png');
                    }else if(skill === "skip") {
                        imageName =  "ring_skip_skip_0_null.png"//require('../images/spark/ring/ring_skip_skip_0_null.png');
                    }else{
                        imageName =  "no_ring.png"//require('../images/spark/ring/no_ring.png');
                    }
                }else if(movement === '1' && sleep === '') {
                    if(skill === "") {
                        imageName = "ring_skip_0_1_null.png"//require('../images/spark/ring/ring_skip_0_1_null.png');
                    }else if(skill === "skip") {
                        imageName ="ring_skip_skip_1_null.png"// require('../images/spark/ring/ring_skip_skip_1_null.png');
                    }else{
                        imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                    }
                }else{
                    imageName ="no_ring.png"// require('../images/spark/ring/no_ring.png');
                }
            }

            return imageName;
    },
    getDailyData360({ commit, dispatch, rootState, state ,getters}: any,value:any){
        const lastDayOfMonts=format(endOfMonth(new Date(value.year+"-"+value.num_month)), 'YYYY-MM-DD')
        let datefirstday=format(subWeeks(new Date(lastDayOfMonts), 51), 'YYYY-MM-DD')
        let lastDate = format(new Date(`${lastDayOfMonts}`), "dd");

        if(lastDate=="Su"||lastDate=="Sa"){
            datefirstday=format(subWeeks(new Date(lastDayOfMonts), 52), 'YYYY-MM-DD')
        }
        
        let firstday = format(new Date(`${datefirstday}`), "dd");
        if(firstday!=="Su"&&firstday!=="Sa"&&firstday!=="Mo"){
            datefirstday=format(startOfISOWeek(new Date(`${datefirstday}`)), 'YYYY-MM-DD')
        }else{
            if(firstday=="Su"){
                datefirstday=format(addDays(new Date(datefirstday), 1), 'YYYY-MM-DD')

            }else if(firstday=="Sa"){
                datefirstday=format(addDays(new Date(datefirstday), 2), 'YYYY-MM-DD')
            }
        }
        let holiday:Array<any>=[]
        let pastmonth:Array<any>=[]
        for(let i=0;i<12;i++){
            const month =format(addMonths(new Date(datefirstday), i), 'M')
            pastmonth.push(month)
        }
        //console.log('pastmonth',pastmonth)
        state.month=pastmonth
        firebase.firestore().collection('/holliday').where('companyid','==',value.company).where('date','>=',`${datefirstday}-01`).get().then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
                const data=doc.data()
                holiday.push(data)        
            })
        })
       
        const answer={0:'very-happy',1:'pretty-good',2:'just-okay',3:'not-great',4:'terrible'}
        const _data:any={}
        firebase.firestore().collection('users_questions').where('users', '==', value.email).where("quest_id", "==", '-Kgs61AHOnpJ3rfyQr6t').where('date', '>=', `${datefirstday}`).get().then( async (querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              if(data.answer||data.answer==0){
                if(!_data[data.date]){
                    _data[data.date]=[]
                }
                _data[data.date]=answer[data.answer]
              }
              
            })
            console.log('_data',_data)
            console.log('state.companyCreatedate',state.companyCreatedate)
            console.log('datefirstday',state.alldays)
            const _daily={}
            let week=0
            let total=0
            let _dailyanswer=0
            for(let i=0;i<364;i++){

                const date =format(addDays(new Date(`${datefirstday}`), i), 'YYYY-MM-DD')
                let weekend = format(date, "dd");
                const _holiday = _.find(holiday, function(value){
                    return value != null && value.date == date;
                });
              
                if(weekend=="Mo"){
                    week++
                    if(!_daily[week]){
                        _daily[week]=[]
                    }
                   // console.log('week',week)
                }
                
                if(weekend!=="Su"&&weekend!=="Sa"&&state.alldays==false){
                    if(date<=state.companyCreatedate){
                        _daily[week].push('holiday')
                    }else
                    if(_holiday){
                        _daily[week].push('holiday')
                        //consistent.push('holiday')
                    }else if(new Date(date)>new Date(lastDayOfMonts)){
                        _daily[week].push('holiday')
                    }else{
                        if(_data[date]){
                            _dailyanswer++
                            total++
                            _daily[week].push(_data[date])
                            //consistent.push(_data[date])
                        }else{
                            total++
                            _daily[week].push('skip')
                            //consistent.push('skip')
                        }
                    }

                }else if(state.alldays==true){
                    if(date<=state.companyCreatedate){
                        _daily[week].push('holiday')
                    }else
                    if(_holiday){
                        _daily[week].push('holiday')
                        //consistent.push('holiday')
                    }else if(new Date(date)>new Date(lastDayOfMonts)){
                        _daily[week].push('holiday')
                    }else{
                        if(_data[date]){
                            _dailyanswer++
                            total++
                            _daily[week].push(_data[date])
                            //consistent.push(_data[date])
                        }else{
                            total++
                            
                            _daily[week].push('skip')
                            //consistent.push('skip')
                        }
                    }

                }
                
               
                
            }
            commit('setConsistent',isNaN(Math.round((_dailyanswer/total)*100)) ? 0 : Math.round((_dailyanswer/total)*100))
            commit('setdailyData',_daily)
        })
    }
   
   
    

  },
  getters: {
    engagement: (state: any) => {
      return state.engagement
    },
    current_dailyCheck: (state: any) => {
      return state.current_dailyCheck
    },
    directReports: (state: any) => {
      return state.directReports
    },
    directReportsData: (state: any) => {
      return {
        engagedValue: state.directReportsEngagedValue,
        engagedData: state.directReportsEngagedData
      }
    },
    directReportsLoading: (state: any) => {
      return state.directReportsLoading
    },
    loading: (state: any) => {
      return state.loading
    },
    userDetail:(state: any) => {
        return state.userDetail
      },
      contributions: (state: any) => {
        return state.dailyContributions
      },
      youFeeling: (state: any) => {
        return state.youFeeling
      },
      teamFeeling: (state: any) => {
        return state.teamFeeling
      },
      feeling: (state: any) => {
        return state.feeling
      },
      performingData: (state: any) => {
        return state.performingData
      },
      userCardData: (state: any) => {
        return state.userCardData
      },
      loadingStatus: (state: any) => {
        return state.loadingStatus
      },
      growingData: (state: any) => {
        return state.growingData
      },
      directReportsCardData: (state: any) => {

        return state.directReportsCardData
      },
      loadingProgress: (state: any) => {

        return state.loadingProgress
      },
      dailyData: (state: any) => {
        return state.dailyData
      },
      alldays: (state: any) => {
        return state.alldays
      },
      month: (state: any) => {
        return state.month
    },
    consistent :(state: any) => {
        return state.consistent
    },
}
}
